/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminBrandSyncHealthResponse,
  AdminCatalogBrandSyncInput,
  AdminCatalogBrandSyncResponse,
  AdminCatalogBrandsResponse,
  AdminCatalogProductReviewsResponse,
  AdminCatalogProductVisibilityResult,
  AdminCatalogSnapshotImportResult,
  AdminCatalogSnapshotPreview,
  AdminDatabaseActivityResponse,
  AdminDeliveryIncludedRecomputeResponse,
  AdminEthncFullSyncInput,
  AdminEthncFullSyncResponse,
  AdminHomepageHeroBrandsResponse,
  AdminHomepageHeroProductsResponse,
  AdminLoginRequest,
  AdminOrdersResponse,
  AdminPieceCountReviewResponse,
  AdminPricingReviewBulkApprovalResult,
  AdminPricingReviewResponse,
  AdminPricingVariantPriceSaveResult,
  AdminPushActionResponse,
  AdminPushDevicesResponse,
  AdminPushPreferenceInput,
  AdminPushSettingsResponse,
  AdminPushSubscribeResponse,
  AdminPushSubscriptionInput,
  AdminPushTestResponse,
  AdminPushUnsubscribeInput,
  AdminSessionResponse,
  AdminSocialPostDraftResponse,
  AdminSocialPostSettings,
  AdminSocialPostUpdateRequest,
  AdminSocialPostsResponse,
  AdminSocialPublishingStatus,
  ApproveAdminPricingReviewsRequest,
  ApproveCatalogProductReviewInput,
  ApproveCatalogProductReviewResponse,
  BrandCatalogPageResponse,
  BrandCatalogProductAvailabilityResponse,
  BrandCatalogProductResponse,
  CatalogBrandSettingsSaveResponse,
  CatalogSearchPage,
  ClearCatalogBrandPendingCollectionsInput,
  ClearCatalogBrandPendingCollectionsResponse,
  CreateOrderRequest,
  CreateOrderResponse,
  DeleteCatalogProductReviewResponse,
  EasternCatalogPageResponse,
  EasternProductAvailabilityResponse,
  EasternProductDetailResponse,
  ErrorResponse,
  ExportSavedOrdersCsvParams,
  GetAdminPricingReviewParams,
  GetHomepageShareImageMetadataParams,
  HealthStatus,
  HomepageShareImageMetadataResponse,
  ListBrandCatalogProductsParams,
  ListEasternProductsParams,
  ListSaleCatalogProductsParams,
  ListShopCatalogProductsParams,
  ManualSocialPostDraftRequest,
  MediaUploadConfirmInput,
  MediaUploadConfirmResponse,
  MediaUploadUrlInput,
  MediaUploadUrlResponse,
  MetaOAuthUrlResponse,
  MetaPageSelectionRequest,
  OrderStatusUpdate,
  PublicCatalogBrandsResponse,
  PublicHomepageSettings,
  RenderAdminSocialPost200,
  ResolveCatalogProductReviewsInput,
  ResolveCatalogProductReviewsResponse,
  SaleCatalogPageResponse,
  SaveAdminPricingVariantPriceRequest,
  SavedOrderDeletion,
  SavedOrderResponse,
  SearchAdminHomepageHeroProductsParams,
  SearchCatalogParams,
  SearchSuggestionsResponse,
  SetAdminCatalogProductVisibilityRequest,
  ShopCatalogPageResponse,
  SocialAutoPublishingRequest,
  StorefrontHomepageHeroResponse,
  StorefrontSettings,
  SuggestCatalogSearchParams,
  UpdateAdminCatalogBrandsRequest,
  UpdateAdminPieceCountRequest,
  UpdateAdminPieceCountResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSearchCatalogUrl = (params: SearchCatalogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search?${stringifiedParams}` : `/api/search`
}

/**
 * @summary Search all active storefront brands
 */
export const searchCatalog = async (params: SearchCatalogParams, options?: Parameters<typeof customFetch>[1]): Promise<CatalogSearchPage> => {

  return customFetch<CatalogSearchPage>(getSearchCatalogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchCatalogQueryKey = (params?: SearchCatalogParams,) => {
    return [
    `/api/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCatalogQueryOptions = <TData = Awaited<ReturnType<typeof searchCatalog>>, TError = ErrorType<ErrorResponse>>(params: SearchCatalogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCatalogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCatalog>>> = ({ signal }) => searchCatalog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof searchCatalog>>>
export type SearchCatalogQueryError = ErrorType<ErrorResponse>


/**
 * @summary Search all active storefront brands
 */

export function useSearchCatalog<TData = Awaited<ReturnType<typeof searchCatalog>>, TError = ErrorType<ErrorResponse>>(
 params: SearchCatalogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchCatalogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSuggestCatalogSearchUrl = (params: SuggestCatalogSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search/suggestions?${stringifiedParams}` : `/api/search/suggestions`
}

/**
 * @summary Suggest products, brands, and categories for storefront search
 */
export const suggestCatalogSearch = async (params: SuggestCatalogSearchParams, options?: Parameters<typeof customFetch>[1]): Promise<SearchSuggestionsResponse> => {

  return customFetch<SearchSuggestionsResponse>(getSuggestCatalogSearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSuggestCatalogSearchQueryKey = (params?: SuggestCatalogSearchParams,) => {
    return [
    `/api/search/suggestions`, ...(params ? [params] : [])
    ] as const;
    }


export const getSuggestCatalogSearchQueryOptions = <TData = Awaited<ReturnType<typeof suggestCatalogSearch>>, TError = ErrorType<ErrorResponse>>(params: SuggestCatalogSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof suggestCatalogSearch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSuggestCatalogSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof suggestCatalogSearch>>> = ({ signal }) => suggestCatalogSearch(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof suggestCatalogSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type SuggestCatalogSearchQueryResult = NonNullable<Awaited<ReturnType<typeof suggestCatalogSearch>>>
export type SuggestCatalogSearchQueryError = ErrorType<ErrorResponse>


/**
 * @summary Suggest products, brands, and categories for storefront search
 */

export function useSuggestCatalogSearch<TData = Awaited<ReturnType<typeof suggestCatalogSearch>>, TError = ErrorType<ErrorResponse>>(
 params: SuggestCatalogSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof suggestCatalogSearch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSuggestCatalogSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListEasternProductsUrl = (params?: ListEasternProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/eastern/products?${stringifiedParams}` : `/api/eastern/products`
}

/**
 * Returns a server-filtered and paginated page of eligible products from the Eastern Pret and Unstitched collections.
 * @summary List Eastern catalog products
 */
export const listEasternProducts = async (params?: ListEasternProductsParams, options?: Parameters<typeof customFetch>[1]): Promise<EasternCatalogPageResponse> => {

  return customFetch<EasternCatalogPageResponse>(getListEasternProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEasternProductsQueryKey = (params?: ListEasternProductsParams,) => {
    return [
    `/api/eastern/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEasternProductsQueryOptions = <TData = Awaited<ReturnType<typeof listEasternProducts>>, TError = ErrorType<ErrorResponse>>(params?: ListEasternProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEasternProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEasternProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEasternProducts>>> = ({ signal }) => listEasternProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEasternProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEasternProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listEasternProducts>>>
export type ListEasternProductsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List Eastern catalog products
 */

export function useListEasternProducts<TData = Awaited<ReturnType<typeof listEasternProducts>>, TError = ErrorType<ErrorResponse>>(
 params?: ListEasternProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEasternProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEasternProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEasternProductUrl = (handle: string,) => {




  return `/api/eastern/products/${handle}`
}

/**
 * Returns the product and its variant availability from the most recent catalog sync.
 * @summary Get an Eastern product
 */
export const getEasternProduct = async (handle: string, options?: Parameters<typeof customFetch>[1]): Promise<EasternProductDetailResponse> => {

  return customFetch<EasternProductDetailResponse>(getGetEasternProductUrl(handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEasternProductQueryKey = (handle: string,) => {
    return [
    `/api/eastern/products/${handle}`
    ] as const;
    }


export const getGetEasternProductQueryOptions = <TData = Awaited<ReturnType<typeof getEasternProduct>>, TError = ErrorType<ErrorResponse>>(handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEasternProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEasternProductQueryKey(handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEasternProduct>>> = ({ signal }) => getEasternProduct(handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEasternProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEasternProductQueryResult = NonNullable<Awaited<ReturnType<typeof getEasternProduct>>>
export type GetEasternProductQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get an Eastern product
 */

export function useGetEasternProduct<TData = Awaited<ReturnType<typeof getEasternProduct>>, TError = ErrorType<ErrorResponse>>(
 handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEasternProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEasternProductQueryOptions(handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEasternProductAvailabilityUrl = (handle: string,) => {




  return `/api/eastern/products/${handle}/availability`
}

/**
 * Returns live variant availability; successful checks are cached server-side for 90 seconds.
 * @summary Check live availability for an Eastern product
 */
export const getEasternProductAvailability = async (handle: string, options?: Parameters<typeof customFetch>[1]): Promise<EasternProductAvailabilityResponse> => {

  return customFetch<EasternProductAvailabilityResponse>(getGetEasternProductAvailabilityUrl(handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEasternProductAvailabilityQueryKey = (handle: string,) => {
    return [
    `/api/eastern/products/${handle}/availability`
    ] as const;
    }


export const getGetEasternProductAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getEasternProductAvailability>>, TError = ErrorType<ErrorResponse>>(handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEasternProductAvailability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEasternProductAvailabilityQueryKey(handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEasternProductAvailability>>> = ({ signal }) => getEasternProductAvailability(handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEasternProductAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEasternProductAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getEasternProductAvailability>>>
export type GetEasternProductAvailabilityQueryError = ErrorType<ErrorResponse>


/**
 * @summary Check live availability for an Eastern product
 */

export function useGetEasternProductAvailability<TData = Awaited<ReturnType<typeof getEasternProductAvailability>>, TError = ErrorType<ErrorResponse>>(
 handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEasternProductAvailability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEasternProductAvailabilityQueryOptions(handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshEasternProductAvailabilityUrl = (handle: string,) => {




  return `/api/eastern/products/${handle}/availability`
}

/**
 * Bypasses the 90-second server cache, fetches live variant availability, then refreshes the cache.
 * @summary Force a fresh availability check for an Eastern product
 */
export const refreshEasternProductAvailability = async (handle: string, options?: Parameters<typeof customFetch>[1]): Promise<EasternProductAvailabilityResponse> => {

  return customFetch<EasternProductAvailabilityResponse>(getRefreshEasternProductAvailabilityUrl(handle),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshEasternProductAvailabilityMutationKey = () => ['refreshEasternProductAvailability'] as const;

export const getRefreshEasternProductAvailabilityMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshEasternProductAvailability>>, TError,RefreshEasternProductAvailabilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshEasternProductAvailability>>, TError,RefreshEasternProductAvailabilityMutationVariables, TContext> => {

const mutationKey = getRefreshEasternProductAvailabilityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshEasternProductAvailability>>, RefreshEasternProductAvailabilityMutationVariables> = (props) => {
          const {handle} = props ?? {};

          return  refreshEasternProductAvailability(handle,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshEasternProductAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof refreshEasternProductAvailability>>>

    export type RefreshEasternProductAvailabilityMutationError = ErrorType<ErrorResponse>
    export type RefreshEasternProductAvailabilityMutationVariables = {handle: string}

    /**
 * @summary Force a fresh availability check for an Eastern product
 */
export const useRefreshEasternProductAvailability = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshEasternProductAvailability>>, TError,RefreshEasternProductAvailabilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshEasternProductAvailability>>,
        TError,
        RefreshEasternProductAvailabilityMutationVariables,
        TContext
      > => {
      return useMutation(getRefreshEasternProductAvailabilityMutationOptions(options));
    }

export const getListPublicCatalogBrandsUrl = () => {




  return `/api/catalog/brands`
}

/**
 * Returns public brand presentation and homepage flags without source configuration details.
 * @summary List approved catalog brands for public merchandising
 */
export const listPublicCatalogBrands = async ( options?: Parameters<typeof customFetch>[1]): Promise<PublicCatalogBrandsResponse> => {

  return customFetch<PublicCatalogBrandsResponse>(getListPublicCatalogBrandsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPublicCatalogBrandsQueryKey = () => {
    return [
    `/api/catalog/brands`
    ] as const;
    }


export const getListPublicCatalogBrandsQueryOptions = <TData = Awaited<ReturnType<typeof listPublicCatalogBrands>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicCatalogBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPublicCatalogBrandsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicCatalogBrands>>> = ({ signal }) => listPublicCatalogBrands({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPublicCatalogBrands>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPublicCatalogBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof listPublicCatalogBrands>>>
export type ListPublicCatalogBrandsQueryError = ErrorType<unknown>


/**
 * @summary List approved catalog brands for public merchandising
 */

export function useListPublicCatalogBrands<TData = Awaited<ReturnType<typeof listPublicCatalogBrands>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicCatalogBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPublicCatalogBrandsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSaleCatalogProductsUrl = (params?: ListSaleCatalogProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/sale?${stringifiedParams}` : `/api/catalog/sale`
}

/**
 * @summary List available sale products across active brands
 */
export const listSaleCatalogProducts = async (params?: ListSaleCatalogProductsParams, options?: Parameters<typeof customFetch>[1]): Promise<SaleCatalogPageResponse> => {

  return customFetch<SaleCatalogPageResponse>(getListSaleCatalogProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSaleCatalogProductsQueryKey = (params?: ListSaleCatalogProductsParams,) => {
    return [
    `/api/catalog/sale`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSaleCatalogProductsQueryOptions = <TData = Awaited<ReturnType<typeof listSaleCatalogProducts>>, TError = ErrorType<ErrorResponse>>(params?: ListSaleCatalogProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSaleCatalogProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSaleCatalogProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSaleCatalogProducts>>> = ({ signal }) => listSaleCatalogProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSaleCatalogProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSaleCatalogProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listSaleCatalogProducts>>>
export type ListSaleCatalogProductsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List available sale products across active brands
 */

export function useListSaleCatalogProducts<TData = Awaited<ReturnType<typeof listSaleCatalogProducts>>, TError = ErrorType<ErrorResponse>>(
 params?: ListSaleCatalogProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSaleCatalogProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSaleCatalogProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListBrandCatalogProductsUrl = (params: ListBrandCatalogProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/products?${stringifiedParams}` : `/api/catalog/products`
}

/**
 * @summary List products from an approved brand catalog
 */
export const listBrandCatalogProducts = async (params: ListBrandCatalogProductsParams, options?: Parameters<typeof customFetch>[1]): Promise<BrandCatalogPageResponse> => {

  return customFetch<BrandCatalogPageResponse>(getListBrandCatalogProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBrandCatalogProductsQueryKey = (params?: ListBrandCatalogProductsParams,) => {
    return [
    `/api/catalog/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBrandCatalogProductsQueryOptions = <TData = Awaited<ReturnType<typeof listBrandCatalogProducts>>, TError = ErrorType<ErrorResponse>>(params: ListBrandCatalogProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBrandCatalogProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandCatalogProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrandCatalogProducts>>> = ({ signal }) => listBrandCatalogProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBrandCatalogProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBrandCatalogProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listBrandCatalogProducts>>>
export type ListBrandCatalogProductsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List products from an approved brand catalog
 */

export function useListBrandCatalogProducts<TData = Awaited<ReturnType<typeof listBrandCatalogProducts>>, TError = ErrorType<ErrorResponse>>(
 params: ListBrandCatalogProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBrandCatalogProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBrandCatalogProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListShopCatalogProductsUrl = (params?: ListShopCatalogProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalog/all?${stringifiedParams}` : `/api/catalog/all`
}

/**
 * Returns 24 server-filtered products at a time. Cursors preserve a deterministic featured interleave across the saved brand order.
 * @summary List all eligible storefront products
 */
export const listShopCatalogProducts = async (params?: ListShopCatalogProductsParams, options?: Parameters<typeof customFetch>[1]): Promise<ShopCatalogPageResponse> => {

  return customFetch<ShopCatalogPageResponse>(getListShopCatalogProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListShopCatalogProductsQueryKey = (params?: ListShopCatalogProductsParams,) => {
    return [
    `/api/catalog/all`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShopCatalogProductsQueryOptions = <TData = Awaited<ReturnType<typeof listShopCatalogProducts>>, TError = ErrorType<ErrorResponse>>(params?: ListShopCatalogProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopCatalogProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShopCatalogProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShopCatalogProducts>>> = ({ signal }) => listShopCatalogProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShopCatalogProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShopCatalogProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listShopCatalogProducts>>>
export type ListShopCatalogProductsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all eligible storefront products
 */

export function useListShopCatalogProducts<TData = Awaited<ReturnType<typeof listShopCatalogProducts>>, TError = ErrorType<ErrorResponse>>(
 params?: ListShopCatalogProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShopCatalogProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShopCatalogProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBrandCatalogProductUrl = (brandSlug: string,
    handle: string,) => {




  return `/api/catalog/brands/${brandSlug}/products/${handle}`
}

/**
 * @summary Get a product from an approved brand catalog
 */
export const getBrandCatalogProduct = async (brandSlug: string,
    handle: string, options?: Parameters<typeof customFetch>[1]): Promise<BrandCatalogProductResponse> => {

  return customFetch<BrandCatalogProductResponse>(getGetBrandCatalogProductUrl(brandSlug,handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandCatalogProductQueryKey = (brandSlug: string,
    handle: string,) => {
    return [
    `/api/catalog/brands/${brandSlug}/products/${handle}`
    ] as const;
    }


export const getGetBrandCatalogProductQueryOptions = <TData = Awaited<ReturnType<typeof getBrandCatalogProduct>>, TError = ErrorType<ErrorResponse>>(brandSlug: string,
    handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrandCatalogProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandCatalogProductQueryKey(brandSlug,handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandCatalogProduct>>> = ({ signal }) => getBrandCatalogProduct(brandSlug,handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: brandSlug !== null && brandSlug !== undefined && handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandCatalogProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBrandCatalogProductQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandCatalogProduct>>>
export type GetBrandCatalogProductQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a product from an approved brand catalog
 */

export function useGetBrandCatalogProduct<TData = Awaited<ReturnType<typeof getBrandCatalogProduct>>, TError = ErrorType<ErrorResponse>>(
 brandSlug: string,
    handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrandCatalogProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBrandCatalogProductQueryOptions(brandSlug,handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBrandCatalogProductAvailabilityUrl = (brandSlug: string,
    handle: string,) => {




  return `/api/catalog/brands/${brandSlug}/products/${handle}/availability`
}

/**
 * Missing availability flags and collection-feed 404 responses retain the last saved availability. This does not use a single-product route.
 * @summary Check catalog-brand size availability from its collection feed
 */
export const getBrandCatalogProductAvailability = async (brandSlug: string,
    handle: string, options?: Parameters<typeof customFetch>[1]): Promise<BrandCatalogProductAvailabilityResponse> => {

  return customFetch<BrandCatalogProductAvailabilityResponse>(getGetBrandCatalogProductAvailabilityUrl(brandSlug,handle),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandCatalogProductAvailabilityQueryKey = (brandSlug: string,
    handle: string,) => {
    return [
    `/api/catalog/brands/${brandSlug}/products/${handle}/availability`
    ] as const;
    }


export const getGetBrandCatalogProductAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>, TError = ErrorType<ErrorResponse>>(brandSlug: string,
    handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandCatalogProductAvailabilityQueryKey(brandSlug,handle);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>> = ({ signal }) => getBrandCatalogProductAvailability(brandSlug,handle, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: brandSlug !== null && brandSlug !== undefined && handle !== null && handle !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBrandCatalogProductAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>>
export type GetBrandCatalogProductAvailabilityQueryError = ErrorType<ErrorResponse>


/**
 * @summary Check catalog-brand size availability from its collection feed
 */

export function useGetBrandCatalogProductAvailability<TData = Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>, TError = ErrorType<ErrorResponse>>(
 brandSlug: string,
    handle: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBrandCatalogProductAvailability>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBrandCatalogProductAvailabilityQueryOptions(brandSlug,handle,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshBrandCatalogProductAvailabilityUrl = (brandSlug: string,
    handle: string,) => {




  return `/api/catalog/brands/${brandSlug}/products/${handle}/availability`
}

/**
 * Forces a fresh collection-feed page request. Missing availability flags and 404 responses retain the last saved availability.
 * @summary Refresh catalog-brand size availability from its collection feed
 */
export const refreshBrandCatalogProductAvailability = async (brandSlug: string,
    handle: string, options?: Parameters<typeof customFetch>[1]): Promise<BrandCatalogProductAvailabilityResponse> => {

  return customFetch<BrandCatalogProductAvailabilityResponse>(getRefreshBrandCatalogProductAvailabilityUrl(brandSlug,handle),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshBrandCatalogProductAvailabilityMutationKey = () => ['refreshBrandCatalogProductAvailability'] as const;

export const getRefreshBrandCatalogProductAvailabilityMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBrandCatalogProductAvailability>>, TError,RefreshBrandCatalogProductAvailabilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshBrandCatalogProductAvailability>>, TError,RefreshBrandCatalogProductAvailabilityMutationVariables, TContext> => {

const mutationKey = getRefreshBrandCatalogProductAvailabilityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshBrandCatalogProductAvailability>>, RefreshBrandCatalogProductAvailabilityMutationVariables> = (props) => {
          const {brandSlug,handle} = props ?? {};

          return  refreshBrandCatalogProductAvailability(brandSlug,handle,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshBrandCatalogProductAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof refreshBrandCatalogProductAvailability>>>

    export type RefreshBrandCatalogProductAvailabilityMutationError = ErrorType<ErrorResponse>
    export type RefreshBrandCatalogProductAvailabilityMutationVariables = {brandSlug: string;handle: string}

    /**
 * @summary Refresh catalog-brand size availability from its collection feed
 */
export const useRefreshBrandCatalogProductAvailability = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBrandCatalogProductAvailability>>, TError,RefreshBrandCatalogProductAvailabilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshBrandCatalogProductAvailability>>,
        TError,
        RefreshBrandCatalogProductAvailabilityMutationVariables,
        TContext
      > => {
      return useMutation(getRefreshBrandCatalogProductAvailabilityMutationOptions(options));
    }

export const getGetStorefrontSettingsUrl = () => {




  return `/api/storefront/settings`
}

/**
 * Returns public pricing, delivery timeline, brands, manual payment instructions, and WhatsApp contact details.
 * @summary Get public storefront settings
 */
export const getStorefrontSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<StorefrontSettings> => {

  return customFetch<StorefrontSettings>(getGetStorefrontSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorefrontSettingsQueryKey = () => {
    return [
    `/api/storefront/settings`
    ] as const;
    }


export const getGetStorefrontSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getStorefrontSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorefrontSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontSettings>>> = ({ signal }) => getStorefrontSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorefrontSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorefrontSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontSettings>>>
export type GetStorefrontSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get public storefront settings
 */

export function useGetStorefrontSettings<TData = Awaited<ReturnType<typeof getStorefrontSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorefrontSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStorefrontHomepageSettingsUrl = () => {




  return `/api/storefront/homepage-settings`
}

/**
 * Returns only homepage copy, section settings, and social links for server-rendered page initialization.
 * @summary Get public homepage copy and social links
 */
export const getStorefrontHomepageSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<PublicHomepageSettings> => {

  return customFetch<PublicHomepageSettings>(getGetStorefrontHomepageSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorefrontHomepageSettingsQueryKey = () => {
    return [
    `/api/storefront/homepage-settings`
    ] as const;
    }


export const getGetStorefrontHomepageSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getStorefrontHomepageSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontHomepageSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorefrontHomepageSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontHomepageSettings>>> = ({ signal }) => getStorefrontHomepageSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorefrontHomepageSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorefrontHomepageSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontHomepageSettings>>>
export type GetStorefrontHomepageSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get public homepage copy and social links
 */

export function useGetStorefrontHomepageSettings<TData = Awaited<ReturnType<typeof getStorefrontHomepageSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontHomepageSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorefrontHomepageSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStorefrontHomepageHeroUrl = () => {




  return `/api/storefront/homepage-hero`
}

/**
 * Returns the current eligible hero products in configured order without scanning the catalog at request time.
 * @summary Get stored homepage hero product choices
 */
export const getStorefrontHomepageHero = async ( options?: Parameters<typeof customFetch>[1]): Promise<StorefrontHomepageHeroResponse> => {

  return customFetch<StorefrontHomepageHeroResponse>(getGetStorefrontHomepageHeroUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorefrontHomepageHeroQueryKey = () => {
    return [
    `/api/storefront/homepage-hero`
    ] as const;
    }


export const getGetStorefrontHomepageHeroQueryOptions = <TData = Awaited<ReturnType<typeof getStorefrontHomepageHero>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontHomepageHero>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorefrontHomepageHeroQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontHomepageHero>>> = ({ signal }) => getStorefrontHomepageHero({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorefrontHomepageHero>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorefrontHomepageHeroQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontHomepageHero>>>
export type GetStorefrontHomepageHeroQueryError = ErrorType<unknown>


/**
 * @summary Get stored homepage hero product choices
 */

export function useGetStorefrontHomepageHero<TData = Awaited<ReturnType<typeof getStorefrontHomepageHero>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontHomepageHero>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorefrontHomepageHeroQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHomepageShareImageMetadataUrl = (params?: GetHomepageShareImageMetadataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/storefront/share-image?${stringifiedParams}` : `/api/storefront/share-image`
}

/**
 * Returns a versioned WebP social image. The homepage uses its uploaded override when present and otherwise generates an image from current hero content; other public pages use generated images.
 * @summary Get a page-specific social image
 */
export const getHomepageShareImageMetadata = async (params?: GetHomepageShareImageMetadataParams, options?: Parameters<typeof customFetch>[1]): Promise<HomepageShareImageMetadataResponse> => {

  return customFetch<HomepageShareImageMetadataResponse>(getGetHomepageShareImageMetadataUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHomepageShareImageMetadataQueryKey = (params?: GetHomepageShareImageMetadataParams,) => {
    return [
    `/api/storefront/share-image`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHomepageShareImageMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getHomepageShareImageMetadata>>, TError = ErrorType<unknown>>(params?: GetHomepageShareImageMetadataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHomepageShareImageMetadata>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHomepageShareImageMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomepageShareImageMetadata>>> = ({ signal }) => getHomepageShareImageMetadata(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHomepageShareImageMetadata>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHomepageShareImageMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getHomepageShareImageMetadata>>>
export type GetHomepageShareImageMetadataQueryError = ErrorType<unknown>


/**
 * @summary Get a page-specific social image
 */

export function useGetHomepageShareImageMetadata<TData = Awaited<ReturnType<typeof getHomepageShareImageMetadata>>, TError = ErrorType<unknown>>(
 params?: GetHomepageShareImageMetadataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHomepageShareImageMetadata>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHomepageShareImageMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicMediaObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * Redirects to a short-lived signed read URL for an uploaded public image.
 * @summary Resolve a public media object
 */
export const getPublicMediaObject = async (filePath: string, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getGetPublicMediaObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicMediaObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicMediaObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMediaObject>>, TError = ErrorType<void | ErrorResponse>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicMediaObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMediaObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMediaObject>>> = ({ signal }) => getPublicMediaObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: filePath !== null && filePath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMediaObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicMediaObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMediaObject>>>
export type GetPublicMediaObjectQueryError = ErrorType<void | ErrorResponse>


/**
 * @summary Resolve a public media object
 */

export function useGetPublicMediaObject<TData = Awaited<ReturnType<typeof getPublicMediaObject>>, TError = ErrorType<void | ErrorResponse>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicMediaObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicMediaObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSavedOrderUrl = () => {




  return `/api/orders`
}

/**
 * Creates a guest order after verifying item availability and calculating prices on the server.
 * @summary Save a customer order
 */
export const createSavedOrder = async (createOrderRequest: CreateOrderRequest, options?: Parameters<typeof customFetch>[1]): Promise<CreateOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CreateOrderResponse>(getCreateSavedOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOrderRequest)
  }
);}





export const getCreateSavedOrderMutationKey = () => ['createSavedOrder'] as const;

export const getCreateSavedOrderMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedOrder>>, TError,CreateSavedOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSavedOrder>>, TError,CreateSavedOrderMutationVariables, TContext> => {

const mutationKey = getCreateSavedOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSavedOrder>>, CreateSavedOrderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSavedOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSavedOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createSavedOrder>>>
    export type CreateSavedOrderMutationBody = BodyType<CreateOrderRequest>
    export type CreateSavedOrderMutationError = ErrorType<ErrorResponse>
    export type CreateSavedOrderMutationVariables = {data: BodyType<CreateOrderRequest>}

    /**
 * @summary Save a customer order
 */
export const useCreateSavedOrder = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedOrder>>, TError,CreateSavedOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSavedOrder>>,
        TError,
        CreateSavedOrderMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSavedOrderMutationOptions(options));
    }

export const getGetAdminSessionUrl = () => {




  return `/api/admin/session`
}

/**
 * @summary Check admin session
 */
export const getAdminSession = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminSessionResponse> => {

  return customFetch<AdminSessionResponse>(getGetAdminSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSessionQueryKey = () => {
    return [
    `/api/admin/session`
    ] as const;
    }


export const getGetAdminSessionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSession>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSession>>> = ({ signal }) => getAdminSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSession>>>
export type GetAdminSessionQueryError = ErrorType<unknown>


/**
 * @summary Check admin session
 */

export function useGetAdminSession<TData = Awaited<ReturnType<typeof getAdminSession>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSessionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLoginAdminUrl = () => {




  return `/api/admin/session`
}

/**
 * @summary Log in to the admin panel
 */
export const loginAdmin = async (adminLoginRequest: AdminLoginRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSessionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSessionResponse>(getLoginAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminLoginRequest)
  }
);}





export const getLoginAdminMutationKey = () => ['loginAdmin'] as const;

export const getLoginAdminMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginAdmin>>, TError,LoginAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginAdmin>>, TError,LoginAdminMutationVariables, TContext> => {

const mutationKey = getLoginAdminMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginAdmin>>, LoginAdminMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  loginAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginAdminMutationResult = NonNullable<Awaited<ReturnType<typeof loginAdmin>>>
    export type LoginAdminMutationBody = BodyType<AdminLoginRequest>
    export type LoginAdminMutationError = ErrorType<ErrorResponse>
    export type LoginAdminMutationVariables = {data: BodyType<AdminLoginRequest>}

    /**
 * @summary Log in to the admin panel
 */
export const useLoginAdmin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginAdmin>>, TError,LoginAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof loginAdmin>>,
        TError,
        LoginAdminMutationVariables,
        TContext
      > => {
      return useMutation(getLoginAdminMutationOptions(options));
    }

export const getLogoutAdminUrl = () => {




  return `/api/admin/session`
}

/**
 * @summary Log out of the admin panel
 */
export const logoutAdmin = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminSessionResponse> => {

  return customFetch<AdminSessionResponse>(getLogoutAdminUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLogoutAdminMutationKey = () => ['logoutAdmin'] as const;

export const getLogoutAdminMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAdmin>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutAdmin>>, TError,void, TContext> => {

const mutationKey = getLogoutAdminMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAdmin>>, void> = () => {


          return  logoutAdmin(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutAdminMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAdmin>>>

    export type LogoutAdminMutationError = ErrorType<unknown>


    /**
 * @summary Log out of the admin panel
 */
export const useLogoutAdmin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAdmin>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutAdmin>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutAdminMutationOptions(options));
    }

export const getGetAdminPushSettingsUrl = () => {




  return `/api/admin/push/settings`
}

/**
 * @summary Read admin web-push preferences
 */
export const getAdminPushSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminPushSettingsResponse> => {

  return customFetch<AdminPushSettingsResponse>(getGetAdminPushSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPushSettingsQueryKey = () => {
    return [
    `/api/admin/push/settings`
    ] as const;
    }


export const getGetAdminPushSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPushSettings>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPushSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPushSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPushSettings>>> = ({ signal }) => getAdminPushSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPushSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPushSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPushSettings>>>
export type GetAdminPushSettingsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Read admin web-push preferences
 */

export function useGetAdminPushSettings<TData = Awaited<ReturnType<typeof getAdminPushSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPushSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPushSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAdminPushPreferenceUrl = () => {




  return `/api/admin/push/settings`
}

/**
 * @summary Update an admin push event preference
 */
export const updateAdminPushPreference = async (adminPushPreferenceInput: AdminPushPreferenceInput, options?: Parameters<typeof customFetch>[1]): Promise<AdminPushSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminPushSettingsResponse>(getUpdateAdminPushPreferenceUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminPushPreferenceInput)
  }
);}





export const getUpdateAdminPushPreferenceMutationKey = () => ['updateAdminPushPreference'] as const;

export const getUpdateAdminPushPreferenceMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminPushPreference>>, TError,UpdateAdminPushPreferenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminPushPreference>>, TError,UpdateAdminPushPreferenceMutationVariables, TContext> => {

const mutationKey = getUpdateAdminPushPreferenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminPushPreference>>, UpdateAdminPushPreferenceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminPushPreference(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminPushPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminPushPreference>>>
    export type UpdateAdminPushPreferenceMutationBody = BodyType<AdminPushPreferenceInput>
    export type UpdateAdminPushPreferenceMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminPushPreferenceMutationVariables = {data: BodyType<AdminPushPreferenceInput>}

    /**
 * @summary Update an admin push event preference
 */
export const useUpdateAdminPushPreference = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminPushPreference>>, TError,UpdateAdminPushPreferenceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminPushPreference>>,
        TError,
        UpdateAdminPushPreferenceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminPushPreferenceMutationOptions(options));
    }

export const getGetAdminPushDevicesUrl = () => {




  return `/api/admin/push/devices`
}

/**
 * @summary List this admin account's push devices
 */
export const getAdminPushDevices = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminPushDevicesResponse> => {

  return customFetch<AdminPushDevicesResponse>(getGetAdminPushDevicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPushDevicesQueryKey = () => {
    return [
    `/api/admin/push/devices`
    ] as const;
    }


export const getGetAdminPushDevicesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPushDevices>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPushDevices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPushDevicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPushDevices>>> = ({ signal }) => getAdminPushDevices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPushDevices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPushDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPushDevices>>>
export type GetAdminPushDevicesQueryError = ErrorType<ErrorResponse>


/**
 * @summary List this admin account's push devices
 */

export function useGetAdminPushDevices<TData = Awaited<ReturnType<typeof getAdminPushDevices>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPushDevices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPushDevicesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteAdminPushDeviceUrl = (id: string,) => {




  return `/api/admin/push/devices/${id}`
}

/**
 * @summary Remove one of this admin account's push devices
 */
export const deleteAdminPushDevice = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminPushActionResponse> => {

  return customFetch<AdminPushActionResponse>(getDeleteAdminPushDeviceUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAdminPushDeviceMutationKey = () => ['deleteAdminPushDevice'] as const;

export const getDeleteAdminPushDeviceMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPushDevice>>, TError,DeleteAdminPushDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPushDevice>>, TError,DeleteAdminPushDeviceMutationVariables, TContext> => {

const mutationKey = getDeleteAdminPushDeviceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminPushDevice>>, DeleteAdminPushDeviceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminPushDevice(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminPushDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminPushDevice>>>

    export type DeleteAdminPushDeviceMutationError = ErrorType<ErrorResponse>
    export type DeleteAdminPushDeviceMutationVariables = {id: string}

    /**
 * @summary Remove one of this admin account's push devices
 */
export const useDeleteAdminPushDevice = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPushDevice>>, TError,DeleteAdminPushDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminPushDevice>>,
        TError,
        DeleteAdminPushDeviceMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdminPushDeviceMutationOptions(options));
    }

export const getSubscribeAdminPushDeviceUrl = () => {




  return `/api/admin/push/subscribe`
}

/**
 * @summary Register this browser for admin push notifications
 */
export const subscribeAdminPushDevice = async (adminPushSubscriptionInput: AdminPushSubscriptionInput, options?: Parameters<typeof customFetch>[1]): Promise<AdminPushSubscribeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminPushSubscribeResponse>(getSubscribeAdminPushDeviceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminPushSubscriptionInput)
  }
);}





export const getSubscribeAdminPushDeviceMutationKey = () => ['subscribeAdminPushDevice'] as const;

export const getSubscribeAdminPushDeviceMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeAdminPushDevice>>, TError,SubscribeAdminPushDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeAdminPushDevice>>, TError,SubscribeAdminPushDeviceMutationVariables, TContext> => {

const mutationKey = getSubscribeAdminPushDeviceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeAdminPushDevice>>, SubscribeAdminPushDeviceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  subscribeAdminPushDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribeAdminPushDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeAdminPushDevice>>>
    export type SubscribeAdminPushDeviceMutationBody = BodyType<AdminPushSubscriptionInput>
    export type SubscribeAdminPushDeviceMutationError = ErrorType<ErrorResponse>
    export type SubscribeAdminPushDeviceMutationVariables = {data: BodyType<AdminPushSubscriptionInput>}

    /**
 * @summary Register this browser for admin push notifications
 */
export const useSubscribeAdminPushDevice = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeAdminPushDevice>>, TError,SubscribeAdminPushDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof subscribeAdminPushDevice>>,
        TError,
        SubscribeAdminPushDeviceMutationVariables,
        TContext
      > => {
      return useMutation(getSubscribeAdminPushDeviceMutationOptions(options));
    }

export const getUnsubscribeAdminPushDeviceUrl = () => {




  return `/api/admin/push/unsubscribe`
}

/**
 * @summary Remove this browser's admin push subscription
 */
export const unsubscribeAdminPushDevice = async (adminPushUnsubscribeInput: AdminPushUnsubscribeInput, options?: Parameters<typeof customFetch>[1]): Promise<AdminPushActionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminPushActionResponse>(getUnsubscribeAdminPushDeviceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminPushUnsubscribeInput)
  }
);}





export const getUnsubscribeAdminPushDeviceMutationKey = () => ['unsubscribeAdminPushDevice'] as const;

export const getUnsubscribeAdminPushDeviceMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeAdminPushDevice>>, TError,UnsubscribeAdminPushDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribeAdminPushDevice>>, TError,UnsubscribeAdminPushDeviceMutationVariables, TContext> => {

const mutationKey = getUnsubscribeAdminPushDeviceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribeAdminPushDevice>>, UnsubscribeAdminPushDeviceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unsubscribeAdminPushDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeAdminPushDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribeAdminPushDevice>>>
    export type UnsubscribeAdminPushDeviceMutationBody = BodyType<AdminPushUnsubscribeInput>
    export type UnsubscribeAdminPushDeviceMutationError = ErrorType<ErrorResponse>
    export type UnsubscribeAdminPushDeviceMutationVariables = {data: BodyType<AdminPushUnsubscribeInput>}

    /**
 * @summary Remove this browser's admin push subscription
 */
export const useUnsubscribeAdminPushDevice = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeAdminPushDevice>>, TError,UnsubscribeAdminPushDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribeAdminPushDevice>>,
        TError,
        UnsubscribeAdminPushDeviceMutationVariables,
        TContext
      > => {
      return useMutation(getUnsubscribeAdminPushDeviceMutationOptions(options));
    }

export const getSendAdminPushTestUrl = () => {




  return `/api/admin/push/test`
}

/**
 * @summary Send a test notification to this admin account's devices
 */
export const sendAdminPushTest = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminPushTestResponse> => {

  return customFetch<AdminPushTestResponse>(getSendAdminPushTestUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendAdminPushTestMutationKey = () => ['sendAdminPushTest'] as const;

export const getSendAdminPushTestMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAdminPushTest>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendAdminPushTest>>, TError,void, TContext> => {

const mutationKey = getSendAdminPushTestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAdminPushTest>>, void> = () => {


          return  sendAdminPushTest(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAdminPushTestMutationResult = NonNullable<Awaited<ReturnType<typeof sendAdminPushTest>>>

    export type SendAdminPushTestMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Send a test notification to this admin account's devices
 */
export const useSendAdminPushTest = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAdminPushTest>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAdminPushTest>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendAdminPushTestMutationOptions(options));
    }

export const getGetAdminDatabaseActivityUrl = () => {




  return `/api/admin/database-activity`
}

/**
 * @summary Read hourly database query counts by source
 */
export const getAdminDatabaseActivity = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminDatabaseActivityResponse> => {

  return customFetch<AdminDatabaseActivityResponse>(getGetAdminDatabaseActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminDatabaseActivityQueryKey = () => {
    return [
    `/api/admin/database-activity`
    ] as const;
    }


export const getGetAdminDatabaseActivityQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDatabaseActivity>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDatabaseActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDatabaseActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDatabaseActivity>>> = ({ signal }) => getAdminDatabaseActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDatabaseActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDatabaseActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDatabaseActivity>>>
export type GetAdminDatabaseActivityQueryError = ErrorType<ErrorResponse>


/**
 * @summary Read hourly database query counts by source
 */

export function useGetAdminDatabaseActivity<TData = Awaited<ReturnType<typeof getAdminDatabaseActivity>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDatabaseActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminDatabaseActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminSettingsUrl = () => {




  return `/api/admin/settings`
}

/**
 * @summary Get editable storefront settings
 */
export const getAdminSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<StorefrontSettings> => {

  return customFetch<StorefrontSettings>(getGetAdminSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSettingsQueryKey = () => {
    return [
    `/api/admin/settings`
    ] as const;
    }


export const getGetAdminSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSettings>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSettings>>> = ({ signal }) => getAdminSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSettings>>>
export type GetAdminSettingsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get editable storefront settings
 */

export function useGetAdminSettings<TData = Awaited<ReturnType<typeof getAdminSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAdminSettingsUrl = () => {




  return `/api/admin/settings`
}

/**
 * @summary Save storefront settings
 */
export const updateAdminSettings = async (storefrontSettings: StorefrontSettings, options?: Parameters<typeof customFetch>[1]): Promise<StorefrontSettings> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StorefrontSettings>(getUpdateAdminSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(storefrontSettings)
  }
);}





export const getUpdateAdminSettingsMutationKey = () => ['updateAdminSettings'] as const;

export const getUpdateAdminSettingsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSettings>>, TError,UpdateAdminSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminSettings>>, TError,UpdateAdminSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateAdminSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminSettings>>, UpdateAdminSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminSettings>>>
    export type UpdateAdminSettingsMutationBody = BodyType<StorefrontSettings>
    export type UpdateAdminSettingsMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminSettingsMutationVariables = {data: BodyType<StorefrontSettings>}

    /**
 * @summary Save storefront settings
 */
export const useUpdateAdminSettings = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSettings>>, TError,UpdateAdminSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminSettings>>,
        TError,
        UpdateAdminSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminSettingsMutationOptions(options));
    }

export const getRecomputeAdminDeliveryIncludedFlagsUrl = () => {




  return `/api/admin/catalog/delivery-included/recompute`
}

/**
 * Recomputes flags from saved piece counts, weights, and shipping rate in batches without fetching source catalogs.
 * @summary Recompute cached delivery-included product flags
 */
export const recomputeAdminDeliveryIncludedFlags = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminDeliveryIncludedRecomputeResponse> => {

  return customFetch<AdminDeliveryIncludedRecomputeResponse>(getRecomputeAdminDeliveryIncludedFlagsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecomputeAdminDeliveryIncludedFlagsMutationKey = () => ['recomputeAdminDeliveryIncludedFlags'] as const;

export const getRecomputeAdminDeliveryIncludedFlagsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recomputeAdminDeliveryIncludedFlags>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recomputeAdminDeliveryIncludedFlags>>, TError,void, TContext> => {

const mutationKey = getRecomputeAdminDeliveryIncludedFlagsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recomputeAdminDeliveryIncludedFlags>>, void> = () => {


          return  recomputeAdminDeliveryIncludedFlags(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecomputeAdminDeliveryIncludedFlagsMutationResult = NonNullable<Awaited<ReturnType<typeof recomputeAdminDeliveryIncludedFlags>>>

    export type RecomputeAdminDeliveryIncludedFlagsMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Recompute cached delivery-included product flags
 */
export const useRecomputeAdminDeliveryIncludedFlags = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recomputeAdminDeliveryIncludedFlags>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recomputeAdminDeliveryIncludedFlags>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRecomputeAdminDeliveryIncludedFlagsMutationOptions(options));
    }

export const getGetAdminHomepageHeroBrandsUrl = () => {




  return `/api/admin/homepage-hero/brands`
}

/**
 * @summary List brands with eligible homepage hero products
 */
export const getAdminHomepageHeroBrands = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminHomepageHeroBrandsResponse> => {

  return customFetch<AdminHomepageHeroBrandsResponse>(getGetAdminHomepageHeroBrandsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminHomepageHeroBrandsQueryKey = () => {
    return [
    `/api/admin/homepage-hero/brands`
    ] as const;
    }


export const getGetAdminHomepageHeroBrandsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminHomepageHeroBrandsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>> = ({ signal }) => getAdminHomepageHeroBrands({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminHomepageHeroBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>>
export type GetAdminHomepageHeroBrandsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List brands with eligible homepage hero products
 */

export function useGetAdminHomepageHeroBrands<TData = Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminHomepageHeroBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminHomepageHeroBrandsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSearchAdminHomepageHeroProductsUrl = (params: SearchAdminHomepageHeroProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/homepage-hero/products?${stringifiedParams}` : `/api/admin/homepage-hero/products`
}

/**
 * @summary Search eligible products for a homepage hero override
 */
export const searchAdminHomepageHeroProducts = async (params: SearchAdminHomepageHeroProductsParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminHomepageHeroProductsResponse> => {

  return customFetch<AdminHomepageHeroProductsResponse>(getSearchAdminHomepageHeroProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAdminHomepageHeroProductsQueryKey = (params?: SearchAdminHomepageHeroProductsParams,) => {
    return [
    `/api/admin/homepage-hero/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAdminHomepageHeroProductsQueryOptions = <TData = Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>, TError = ErrorType<ErrorResponse>>(params: SearchAdminHomepageHeroProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAdminHomepageHeroProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>> = ({ signal }) => searchAdminHomepageHeroProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchAdminHomepageHeroProductsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>>
export type SearchAdminHomepageHeroProductsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Search eligible products for a homepage hero override
 */

export function useSearchAdminHomepageHeroProducts<TData = Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>, TError = ErrorType<ErrorResponse>>(
 params: SearchAdminHomepageHeroProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchAdminHomepageHeroProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchAdminHomepageHeroProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestAdminMediaUploadUrlUrl = () => {




  return `/api/admin/media/uploads/request-url`
}

/**
 * @summary Request a same-origin upload path for a compressed image
 */
export const requestAdminMediaUploadUrl = async (mediaUploadUrlInput: MediaUploadUrlInput, options?: Parameters<typeof customFetch>[1]): Promise<MediaUploadUrlResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MediaUploadUrlResponse>(getRequestAdminMediaUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mediaUploadUrlInput)
  }
);}





export const getRequestAdminMediaUploadUrlMutationKey = () => ['requestAdminMediaUploadUrl'] as const;

export const getRequestAdminMediaUploadUrlMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAdminMediaUploadUrl>>, TError,RequestAdminMediaUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAdminMediaUploadUrl>>, TError,RequestAdminMediaUploadUrlMutationVariables, TContext> => {

const mutationKey = getRequestAdminMediaUploadUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAdminMediaUploadUrl>>, RequestAdminMediaUploadUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestAdminMediaUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestAdminMediaUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestAdminMediaUploadUrl>>>
    export type RequestAdminMediaUploadUrlMutationBody = BodyType<MediaUploadUrlInput>
    export type RequestAdminMediaUploadUrlMutationError = ErrorType<ErrorResponse>
    export type RequestAdminMediaUploadUrlMutationVariables = {data: BodyType<MediaUploadUrlInput>}

    /**
 * @summary Request a same-origin upload path for a compressed image
 */
export const useRequestAdminMediaUploadUrl = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAdminMediaUploadUrl>>, TError,RequestAdminMediaUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestAdminMediaUploadUrl>>,
        TError,
        RequestAdminMediaUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getRequestAdminMediaUploadUrlMutationOptions(options));
    }

export const getUploadAdminMediaContentUrl = () => {




  return `/api/admin/media/uploads/content`
}

/**
 * @summary Upload compressed image bytes through the API server
 */
export const uploadAdminMediaContent = async (uploadAdminMediaContentBody: Blob, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getUploadAdminMediaContentUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'image/webp', ...getHeaders(options?.headers) },
    body: uploadAdminMediaContentBody
  }
);}





export const getUploadAdminMediaContentMutationKey = () => ['uploadAdminMediaContent'] as const;

export const getUploadAdminMediaContentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAdminMediaContent>>, TError,UploadAdminMediaContentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadAdminMediaContent>>, TError,UploadAdminMediaContentMutationVariables, TContext> => {

const mutationKey = getUploadAdminMediaContentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAdminMediaContent>>, UploadAdminMediaContentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadAdminMediaContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadAdminMediaContentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAdminMediaContent>>>
    export type UploadAdminMediaContentMutationBody = BodyType<Blob>
    export type UploadAdminMediaContentMutationError = ErrorType<ErrorResponse>
    export type UploadAdminMediaContentMutationVariables = {data: BodyType<Blob>}

    /**
 * @summary Upload compressed image bytes through the API server
 */
export const useUploadAdminMediaContent = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAdminMediaContent>>, TError,UploadAdminMediaContentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadAdminMediaContent>>,
        TError,
        UploadAdminMediaContentMutationVariables,
        TContext
      > => {
      return useMutation(getUploadAdminMediaContentMutationOptions(options));
    }

export const getConfirmAdminMediaUploadUrl = () => {




  return `/api/admin/media/uploads/confirm`
}

/**
 * @summary Verify an uploaded image before it can be used
 */
export const confirmAdminMediaUpload = async (mediaUploadConfirmInput: MediaUploadConfirmInput, options?: Parameters<typeof customFetch>[1]): Promise<MediaUploadConfirmResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MediaUploadConfirmResponse>(getConfirmAdminMediaUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mediaUploadConfirmInput)
  }
);}





export const getConfirmAdminMediaUploadMutationKey = () => ['confirmAdminMediaUpload'] as const;

export const getConfirmAdminMediaUploadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAdminMediaUpload>>, TError,ConfirmAdminMediaUploadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmAdminMediaUpload>>, TError,ConfirmAdminMediaUploadMutationVariables, TContext> => {

const mutationKey = getConfirmAdminMediaUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmAdminMediaUpload>>, ConfirmAdminMediaUploadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmAdminMediaUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmAdminMediaUploadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmAdminMediaUpload>>>
    export type ConfirmAdminMediaUploadMutationBody = BodyType<MediaUploadConfirmInput>
    export type ConfirmAdminMediaUploadMutationError = ErrorType<ErrorResponse>
    export type ConfirmAdminMediaUploadMutationVariables = {data: BodyType<MediaUploadConfirmInput>}

    /**
 * @summary Verify an uploaded image before it can be used
 */
export const useConfirmAdminMediaUpload = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAdminMediaUpload>>, TError,ConfirmAdminMediaUploadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmAdminMediaUpload>>,
        TError,
        ConfirmAdminMediaUploadMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmAdminMediaUploadMutationOptions(options));
    }

export const getListAdminCatalogBrandsUrl = () => {




  return `/api/admin/brands`
}

/**
 * @summary List configured catalog brands
 */
export const listAdminCatalogBrands = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminCatalogBrandsResponse> => {

  return customFetch<AdminCatalogBrandsResponse>(getListAdminCatalogBrandsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCatalogBrandsQueryKey = () => {
    return [
    `/api/admin/brands`
    ] as const;
    }


export const getListAdminCatalogBrandsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCatalogBrands>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminCatalogBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminCatalogBrandsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCatalogBrands>>> = ({ signal }) => listAdminCatalogBrands({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCatalogBrands>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminCatalogBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCatalogBrands>>>
export type ListAdminCatalogBrandsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List configured catalog brands
 */

export function useListAdminCatalogBrands<TData = Awaited<ReturnType<typeof listAdminCatalogBrands>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminCatalogBrands>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminCatalogBrandsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAdminCatalogBrandsUrl = () => {




  return `/api/admin/brands`
}

/**
 * @summary Update configured catalog brands
 */
export const updateAdminCatalogBrands = async (updateAdminCatalogBrandsRequest: UpdateAdminCatalogBrandsRequest, options?: Parameters<typeof customFetch>[1]): Promise<CatalogBrandSettingsSaveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CatalogBrandSettingsSaveResponse>(getUpdateAdminCatalogBrandsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAdminCatalogBrandsRequest)
  }
);}





export const getUpdateAdminCatalogBrandsMutationKey = () => ['updateAdminCatalogBrands'] as const;

export const getUpdateAdminCatalogBrandsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminCatalogBrands>>, TError,UpdateAdminCatalogBrandsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminCatalogBrands>>, TError,UpdateAdminCatalogBrandsMutationVariables, TContext> => {

const mutationKey = getUpdateAdminCatalogBrandsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminCatalogBrands>>, UpdateAdminCatalogBrandsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminCatalogBrands(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminCatalogBrandsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminCatalogBrands>>>
    export type UpdateAdminCatalogBrandsMutationBody = BodyType<UpdateAdminCatalogBrandsRequest>
    export type UpdateAdminCatalogBrandsMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminCatalogBrandsMutationVariables = {data: BodyType<UpdateAdminCatalogBrandsRequest>}

    /**
 * @summary Update configured catalog brands
 */
export const useUpdateAdminCatalogBrands = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminCatalogBrands>>, TError,UpdateAdminCatalogBrandsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminCatalogBrands>>,
        TError,
        UpdateAdminCatalogBrandsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminCatalogBrandsMutationOptions(options));
    }

export const getClearAdminCatalogBrandPendingCollectionsUrl = (brandSlug: string,) => {




  return `/api/admin/brands/${brandSlug}/pending-collections/clear`
}

/**
 * @summary Clear pending collection review data for one brand
 */
export const clearAdminCatalogBrandPendingCollections = async (brandSlug: string,
    clearCatalogBrandPendingCollectionsInput: ClearCatalogBrandPendingCollectionsInput, options?: Parameters<typeof customFetch>[1]): Promise<ClearCatalogBrandPendingCollectionsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ClearCatalogBrandPendingCollectionsResponse>(getClearAdminCatalogBrandPendingCollectionsUrl(brandSlug),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clearCatalogBrandPendingCollectionsInput)
  }
);}





export const getClearAdminCatalogBrandPendingCollectionsMutationKey = () => ['clearAdminCatalogBrandPendingCollections'] as const;

export const getClearAdminCatalogBrandPendingCollectionsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAdminCatalogBrandPendingCollections>>, TError,ClearAdminCatalogBrandPendingCollectionsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearAdminCatalogBrandPendingCollections>>, TError,ClearAdminCatalogBrandPendingCollectionsMutationVariables, TContext> => {

const mutationKey = getClearAdminCatalogBrandPendingCollectionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearAdminCatalogBrandPendingCollections>>, ClearAdminCatalogBrandPendingCollectionsMutationVariables> = (props) => {
          const {brandSlug,data} = props ?? {};

          return  clearAdminCatalogBrandPendingCollections(brandSlug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearAdminCatalogBrandPendingCollectionsMutationResult = NonNullable<Awaited<ReturnType<typeof clearAdminCatalogBrandPendingCollections>>>
    export type ClearAdminCatalogBrandPendingCollectionsMutationBody = BodyType<ClearCatalogBrandPendingCollectionsInput>
    export type ClearAdminCatalogBrandPendingCollectionsMutationError = ErrorType<ErrorResponse>
    export type ClearAdminCatalogBrandPendingCollectionsMutationVariables = {brandSlug: string;data: BodyType<ClearCatalogBrandPendingCollectionsInput>}

    /**
 * @summary Clear pending collection review data for one brand
 */
export const useClearAdminCatalogBrandPendingCollections = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAdminCatalogBrandPendingCollections>>, TError,ClearAdminCatalogBrandPendingCollectionsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof clearAdminCatalogBrandPendingCollections>>,
        TError,
        ClearAdminCatalogBrandPendingCollectionsMutationVariables,
        TContext
      > => {
      return useMutation(getClearAdminCatalogBrandPendingCollectionsMutationOptions(options));
    }

export const getGetAdminBrandSyncHealthUrl = () => {




  return `/api/admin/brands/health`
}

/**
 * @summary Get catalog sync health by brand
 */
export const getAdminBrandSyncHealth = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminBrandSyncHealthResponse> => {

  return customFetch<AdminBrandSyncHealthResponse>(getGetAdminBrandSyncHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminBrandSyncHealthQueryKey = () => {
    return [
    `/api/admin/brands/health`
    ] as const;
    }


export const getGetAdminBrandSyncHealthQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBrandSyncHealth>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBrandSyncHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBrandSyncHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBrandSyncHealth>>> = ({ signal }) => getAdminBrandSyncHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBrandSyncHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminBrandSyncHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBrandSyncHealth>>>
export type GetAdminBrandSyncHealthQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get catalog sync health by brand
 */

export function useGetAdminBrandSyncHealth<TData = Awaited<ReturnType<typeof getAdminBrandSyncHealth>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBrandSyncHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminBrandSyncHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunAdminEthncFullSyncUrl = () => {




  return `/api/admin/brands/ethnc/sync`
}

/**
 * Fetches the approved live feeds, requires explicit confirmation, and makes no catalog deletions.
 * @summary Run a protected full Ethnc feed refresh
 */
export const runAdminEthncFullSync = async (adminEthncFullSyncInput: AdminEthncFullSyncInput, options?: Parameters<typeof customFetch>[1]): Promise<AdminEthncFullSyncResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminEthncFullSyncResponse>(getRunAdminEthncFullSyncUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminEthncFullSyncInput)
  }
);}





export const getRunAdminEthncFullSyncMutationKey = () => ['runAdminEthncFullSync'] as const;

export const getRunAdminEthncFullSyncMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAdminEthncFullSync>>, TError,RunAdminEthncFullSyncMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runAdminEthncFullSync>>, TError,RunAdminEthncFullSyncMutationVariables, TContext> => {

const mutationKey = getRunAdminEthncFullSyncMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runAdminEthncFullSync>>, RunAdminEthncFullSyncMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  runAdminEthncFullSync(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunAdminEthncFullSyncMutationResult = NonNullable<Awaited<ReturnType<typeof runAdminEthncFullSync>>>
    export type RunAdminEthncFullSyncMutationBody = BodyType<AdminEthncFullSyncInput>
    export type RunAdminEthncFullSyncMutationError = ErrorType<ErrorResponse>
    export type RunAdminEthncFullSyncMutationVariables = {data: BodyType<AdminEthncFullSyncInput>}

    /**
 * @summary Run a protected full Ethnc feed refresh
 */
export const useRunAdminEthncFullSync = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAdminEthncFullSync>>, TError,RunAdminEthncFullSyncMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runAdminEthncFullSync>>,
        TError,
        RunAdminEthncFullSyncMutationVariables,
        TContext
      > => {
      return useMutation(getRunAdminEthncFullSyncMutationOptions(options));
    }

export const getRunAdminCatalogBrandSyncUrl = (brandSlug: string,) => {




  return `/api/admin/brands/${brandSlug}/sync`
}

/**
 * Requires an active, permission-confirmed brand and explicit confirmation. Products missing from feeds are retained.
 * @summary Run a protected full catalog-brand refresh
 */
export const runAdminCatalogBrandSync = async (brandSlug: string,
    adminCatalogBrandSyncInput: AdminCatalogBrandSyncInput, options?: Parameters<typeof customFetch>[1]): Promise<AdminCatalogBrandSyncResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminCatalogBrandSyncResponse>(getRunAdminCatalogBrandSyncUrl(brandSlug),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminCatalogBrandSyncInput)
  }
);}





export const getRunAdminCatalogBrandSyncMutationKey = () => ['runAdminCatalogBrandSync'] as const;

export const getRunAdminCatalogBrandSyncMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAdminCatalogBrandSync>>, TError,RunAdminCatalogBrandSyncMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runAdminCatalogBrandSync>>, TError,RunAdminCatalogBrandSyncMutationVariables, TContext> => {

const mutationKey = getRunAdminCatalogBrandSyncMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runAdminCatalogBrandSync>>, RunAdminCatalogBrandSyncMutationVariables> = (props) => {
          const {brandSlug,data} = props ?? {};

          return  runAdminCatalogBrandSync(brandSlug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunAdminCatalogBrandSyncMutationResult = NonNullable<Awaited<ReturnType<typeof runAdminCatalogBrandSync>>>
    export type RunAdminCatalogBrandSyncMutationBody = BodyType<AdminCatalogBrandSyncInput>
    export type RunAdminCatalogBrandSyncMutationError = ErrorType<ErrorResponse>
    export type RunAdminCatalogBrandSyncMutationVariables = {brandSlug: string;data: BodyType<AdminCatalogBrandSyncInput>}

    /**
 * @summary Run a protected full catalog-brand refresh
 */
export const useRunAdminCatalogBrandSync = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAdminCatalogBrandSync>>, TError,RunAdminCatalogBrandSyncMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runAdminCatalogBrandSync>>,
        TError,
        RunAdminCatalogBrandSyncMutationVariables,
        TContext
      > => {
      return useMutation(getRunAdminCatalogBrandSyncMutationOptions(options));
    }

export const getGetAdminPieceCountReviewUrl = () => {




  return `/api/admin/catalog/piece-counts`
}

/**
 * @summary List piece-count audit totals and products requiring confirmation
 */
export const getAdminPieceCountReview = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminPieceCountReviewResponse> => {

  return customFetch<AdminPieceCountReviewResponse>(getGetAdminPieceCountReviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPieceCountReviewQueryKey = () => {
    return [
    `/api/admin/catalog/piece-counts`
    ] as const;
    }


export const getGetAdminPieceCountReviewQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPieceCountReview>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPieceCountReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPieceCountReviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPieceCountReview>>> = ({ signal }) => getAdminPieceCountReview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPieceCountReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPieceCountReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPieceCountReview>>>
export type GetAdminPieceCountReviewQueryError = ErrorType<ErrorResponse>


/**
 * @summary List piece-count audit totals and products requiring confirmation
 */

export function useGetAdminPieceCountReview<TData = Awaited<ReturnType<typeof getAdminPieceCountReview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPieceCountReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPieceCountReviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveAdminPieceCountUrl = () => {




  return `/api/admin/catalog/piece-counts`
}

/**
 * @summary Confirm a manual piece count or return a product to automatic detection
 */
export const saveAdminPieceCount = async (updateAdminPieceCountRequest: UpdateAdminPieceCountRequest, options?: Parameters<typeof customFetch>[1]): Promise<UpdateAdminPieceCountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UpdateAdminPieceCountResponse>(getSaveAdminPieceCountUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAdminPieceCountRequest)
  }
);}





export const getSaveAdminPieceCountMutationKey = () => ['saveAdminPieceCount'] as const;

export const getSaveAdminPieceCountMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAdminPieceCount>>, TError,SaveAdminPieceCountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAdminPieceCount>>, TError,SaveAdminPieceCountMutationVariables, TContext> => {

const mutationKey = getSaveAdminPieceCountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAdminPieceCount>>, SaveAdminPieceCountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveAdminPieceCount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAdminPieceCountMutationResult = NonNullable<Awaited<ReturnType<typeof saveAdminPieceCount>>>
    export type SaveAdminPieceCountMutationBody = BodyType<UpdateAdminPieceCountRequest>
    export type SaveAdminPieceCountMutationError = ErrorType<ErrorResponse>
    export type SaveAdminPieceCountMutationVariables = {data: BodyType<UpdateAdminPieceCountRequest>}

    /**
 * @summary Confirm a manual piece count or return a product to automatic detection
 */
export const useSaveAdminPieceCount = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAdminPieceCount>>, TError,SaveAdminPieceCountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveAdminPieceCount>>,
        TError,
        SaveAdminPieceCountMutationVariables,
        TContext
      > => {
      return useMutation(getSaveAdminPieceCountMutationOptions(options));
    }

export const getGetAdminPricingReviewUrl = (params?: GetAdminPricingReviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/catalog/pricing-review?${stringifiedParams}` : `/api/admin/catalog/pricing-review`
}

/**
 * @summary Search and filter source catalog pricing reviews
 */
export const getAdminPricingReview = async (params?: GetAdminPricingReviewParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminPricingReviewResponse> => {

  return customFetch<AdminPricingReviewResponse>(getGetAdminPricingReviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminPricingReviewQueryKey = (params?: GetAdminPricingReviewParams,) => {
    return [
    `/api/admin/catalog/pricing-review`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminPricingReviewQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPricingReview>>, TError = ErrorType<ErrorResponse>>(params?: GetAdminPricingReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPricingReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPricingReviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPricingReview>>> = ({ signal }) => getAdminPricingReview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPricingReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPricingReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPricingReview>>>
export type GetAdminPricingReviewQueryError = ErrorType<ErrorResponse>


/**
 * @summary Search and filter source catalog pricing reviews
 */

export function useGetAdminPricingReview<TData = Awaited<ReturnType<typeof getAdminPricingReview>>, TError = ErrorType<ErrorResponse>>(
 params?: GetAdminPricingReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPricingReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPricingReviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveAdminPricingReviewsUrl = () => {




  return `/api/admin/catalog/pricing-review/approve`
}

/**
 * @summary Approve the current source-price snapshots for selected products
 */
export const approveAdminPricingReviews = async (approveAdminPricingReviewsRequest: ApproveAdminPricingReviewsRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminPricingReviewBulkApprovalResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminPricingReviewBulkApprovalResult>(getApproveAdminPricingReviewsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(approveAdminPricingReviewsRequest)
  }
);}





export const getApproveAdminPricingReviewsMutationKey = () => ['approveAdminPricingReviews'] as const;

export const getApproveAdminPricingReviewsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminPricingReviews>>, TError,ApproveAdminPricingReviewsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminPricingReviews>>, TError,ApproveAdminPricingReviewsMutationVariables, TContext> => {

const mutationKey = getApproveAdminPricingReviewsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminPricingReviews>>, ApproveAdminPricingReviewsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  approveAdminPricingReviews(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminPricingReviewsMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminPricingReviews>>>
    export type ApproveAdminPricingReviewsMutationBody = BodyType<ApproveAdminPricingReviewsRequest>
    export type ApproveAdminPricingReviewsMutationError = ErrorType<ErrorResponse>
    export type ApproveAdminPricingReviewsMutationVariables = {data: BodyType<ApproveAdminPricingReviewsRequest>}

    /**
 * @summary Approve the current source-price snapshots for selected products
 */
export const useApproveAdminPricingReviews = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminPricingReviews>>, TError,ApproveAdminPricingReviewsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminPricingReviews>>,
        TError,
        ApproveAdminPricingReviewsMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAdminPricingReviewsMutationOptions(options));
    }

export const getSaveAdminPricingVariantPriceUrl = () => {




  return `/api/admin/catalog/pricing-review/variant`
}

/**
 * @summary Save a manual price correction for one product variant
 */
export const saveAdminPricingVariantPrice = async (saveAdminPricingVariantPriceRequest: SaveAdminPricingVariantPriceRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminPricingVariantPriceSaveResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminPricingVariantPriceSaveResult>(getSaveAdminPricingVariantPriceUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveAdminPricingVariantPriceRequest)
  }
);}





export const getSaveAdminPricingVariantPriceMutationKey = () => ['saveAdminPricingVariantPrice'] as const;

export const getSaveAdminPricingVariantPriceMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAdminPricingVariantPrice>>, TError,SaveAdminPricingVariantPriceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAdminPricingVariantPrice>>, TError,SaveAdminPricingVariantPriceMutationVariables, TContext> => {

const mutationKey = getSaveAdminPricingVariantPriceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAdminPricingVariantPrice>>, SaveAdminPricingVariantPriceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveAdminPricingVariantPrice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAdminPricingVariantPriceMutationResult = NonNullable<Awaited<ReturnType<typeof saveAdminPricingVariantPrice>>>
    export type SaveAdminPricingVariantPriceMutationBody = BodyType<SaveAdminPricingVariantPriceRequest>
    export type SaveAdminPricingVariantPriceMutationError = ErrorType<ErrorResponse>
    export type SaveAdminPricingVariantPriceMutationVariables = {data: BodyType<SaveAdminPricingVariantPriceRequest>}

    /**
 * @summary Save a manual price correction for one product variant
 */
export const useSaveAdminPricingVariantPrice = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAdminPricingVariantPrice>>, TError,SaveAdminPricingVariantPriceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveAdminPricingVariantPrice>>,
        TError,
        SaveAdminPricingVariantPriceMutationVariables,
        TContext
      > => {
      return useMutation(getSaveAdminPricingVariantPriceMutationOptions(options));
    }

export const getExportAdminCatalogSnapshotUrl = () => {




  return `/api/admin/catalog/snapshot/export`
}

/**
 * @summary Download a catalog-only transfer snapshot
 */
export const exportAdminCatalogSnapshot = async ( options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getExportAdminCatalogSnapshotUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportAdminCatalogSnapshotQueryKey = () => {
    return [
    `/api/admin/catalog/snapshot/export`
    ] as const;
    }


export const getExportAdminCatalogSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportAdminCatalogSnapshotQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>> = ({ signal }) => exportAdminCatalogSnapshot({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportAdminCatalogSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>>
export type ExportAdminCatalogSnapshotQueryError = ErrorType<ErrorResponse>


/**
 * @summary Download a catalog-only transfer snapshot
 */

export function useExportAdminCatalogSnapshot<TData = Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportAdminCatalogSnapshot>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportAdminCatalogSnapshotQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewAdminCatalogSnapshotUrl = () => {




  return `/api/admin/catalog/snapshot/preview`
}

/**
 * @summary Validate and preview a catalog snapshot
 */
export const previewAdminCatalogSnapshot = async (previewAdminCatalogSnapshotBody: Blob, options?: Parameters<typeof customFetch>[1]): Promise<AdminCatalogSnapshotPreview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminCatalogSnapshotPreview>(getPreviewAdminCatalogSnapshotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/gzip', ...getHeaders(options?.headers) },
    body: previewAdminCatalogSnapshotBody
  }
);}





export const getPreviewAdminCatalogSnapshotMutationKey = () => ['previewAdminCatalogSnapshot'] as const;

export const getPreviewAdminCatalogSnapshotMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewAdminCatalogSnapshot>>, TError,PreviewAdminCatalogSnapshotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewAdminCatalogSnapshot>>, TError,PreviewAdminCatalogSnapshotMutationVariables, TContext> => {

const mutationKey = getPreviewAdminCatalogSnapshotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewAdminCatalogSnapshot>>, PreviewAdminCatalogSnapshotMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  previewAdminCatalogSnapshot(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewAdminCatalogSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof previewAdminCatalogSnapshot>>>
    export type PreviewAdminCatalogSnapshotMutationBody = BodyType<Blob>
    export type PreviewAdminCatalogSnapshotMutationError = ErrorType<ErrorResponse>
    export type PreviewAdminCatalogSnapshotMutationVariables = {data: BodyType<Blob>}

    /**
 * @summary Validate and preview a catalog snapshot
 */
export const usePreviewAdminCatalogSnapshot = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewAdminCatalogSnapshot>>, TError,PreviewAdminCatalogSnapshotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewAdminCatalogSnapshot>>,
        TError,
        PreviewAdminCatalogSnapshotMutationVariables,
        TContext
      > => {
      return useMutation(getPreviewAdminCatalogSnapshotMutationOptions(options));
    }

export const getImportAdminCatalogSnapshotUrl = () => {




  return `/api/admin/catalog/snapshot/import`
}

/**
 * @summary Import an explicitly confirmed brand catalog snapshot
 */
export const importAdminCatalogSnapshot = async (importAdminCatalogSnapshotBody: Blob, options?: Parameters<typeof customFetch>[1]): Promise<AdminCatalogSnapshotImportResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminCatalogSnapshotImportResult>(getImportAdminCatalogSnapshotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/gzip', ...getHeaders(options?.headers) },
    body: importAdminCatalogSnapshotBody
  }
);}





export const getImportAdminCatalogSnapshotMutationKey = () => ['importAdminCatalogSnapshot'] as const;

export const getImportAdminCatalogSnapshotMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAdminCatalogSnapshot>>, TError,ImportAdminCatalogSnapshotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importAdminCatalogSnapshot>>, TError,ImportAdminCatalogSnapshotMutationVariables, TContext> => {

const mutationKey = getImportAdminCatalogSnapshotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importAdminCatalogSnapshot>>, ImportAdminCatalogSnapshotMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  importAdminCatalogSnapshot(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportAdminCatalogSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof importAdminCatalogSnapshot>>>
    export type ImportAdminCatalogSnapshotMutationBody = BodyType<Blob>
    export type ImportAdminCatalogSnapshotMutationError = ErrorType<ErrorResponse>
    export type ImportAdminCatalogSnapshotMutationVariables = {data: BodyType<Blob>}

    /**
 * @summary Import an explicitly confirmed brand catalog snapshot
 */
export const useImportAdminCatalogSnapshot = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importAdminCatalogSnapshot>>, TError,ImportAdminCatalogSnapshotMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importAdminCatalogSnapshot>>,
        TError,
        ImportAdminCatalogSnapshotMutationVariables,
        TContext
      > => {
      return useMutation(getImportAdminCatalogSnapshotMutationOptions(options));
    }

export const getSetAdminCatalogProductVisibilityUrl = () => {




  return `/api/admin/catalog/products/visibility`
}

/**
 * @summary Hide or show a catalog product on the storefront
 */
export const setAdminCatalogProductVisibility = async (setAdminCatalogProductVisibilityRequest: SetAdminCatalogProductVisibilityRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminCatalogProductVisibilityResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminCatalogProductVisibilityResult>(getSetAdminCatalogProductVisibilityUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setAdminCatalogProductVisibilityRequest)
  }
);}





export const getSetAdminCatalogProductVisibilityMutationKey = () => ['setAdminCatalogProductVisibility'] as const;

export const getSetAdminCatalogProductVisibilityMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminCatalogProductVisibility>>, TError,SetAdminCatalogProductVisibilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminCatalogProductVisibility>>, TError,SetAdminCatalogProductVisibilityMutationVariables, TContext> => {

const mutationKey = getSetAdminCatalogProductVisibilityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminCatalogProductVisibility>>, SetAdminCatalogProductVisibilityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAdminCatalogProductVisibility(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminCatalogProductVisibilityMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminCatalogProductVisibility>>>
    export type SetAdminCatalogProductVisibilityMutationBody = BodyType<SetAdminCatalogProductVisibilityRequest>
    export type SetAdminCatalogProductVisibilityMutationError = ErrorType<ErrorResponse>
    export type SetAdminCatalogProductVisibilityMutationVariables = {data: BodyType<SetAdminCatalogProductVisibilityRequest>}

    /**
 * @summary Hide or show a catalog product on the storefront
 */
export const useSetAdminCatalogProductVisibility = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminCatalogProductVisibility>>, TError,SetAdminCatalogProductVisibilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminCatalogProductVisibility>>,
        TError,
        SetAdminCatalogProductVisibilityMutationVariables,
        TContext
      > => {
      return useMutation(getSetAdminCatalogProductVisibilityMutationOptions(options));
    }

export const getGetAdminCatalogProductReviewsUrl = () => {




  return `/api/admin/brands/reviews`
}

/**
 * @summary List products that need review
 */
export const getAdminCatalogProductReviews = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminCatalogProductReviewsResponse> => {

  return customFetch<AdminCatalogProductReviewsResponse>(getGetAdminCatalogProductReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCatalogProductReviewsQueryKey = () => {
    return [
    `/api/admin/brands/reviews`
    ] as const;
    }


export const getGetAdminCatalogProductReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCatalogProductReviews>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminCatalogProductReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCatalogProductReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCatalogProductReviews>>> = ({ signal }) => getAdminCatalogProductReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCatalogProductReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminCatalogProductReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCatalogProductReviews>>>
export type GetAdminCatalogProductReviewsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List products that need review
 */

export function useGetAdminCatalogProductReviews<TData = Awaited<ReturnType<typeof getAdminCatalogProductReviews>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminCatalogProductReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminCatalogProductReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveAdminCatalogProductReviewUrl = () => {




  return `/api/admin/brands/reviews/approve`
}

/**
 * @summary Approve a product for its current source-data snapshot
 */
export const approveAdminCatalogProductReview = async (approveCatalogProductReviewInput: ApproveCatalogProductReviewInput, options?: Parameters<typeof customFetch>[1]): Promise<ApproveCatalogProductReviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ApproveCatalogProductReviewResponse>(getApproveAdminCatalogProductReviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(approveCatalogProductReviewInput)
  }
);}





export const getApproveAdminCatalogProductReviewMutationKey = () => ['approveAdminCatalogProductReview'] as const;

export const getApproveAdminCatalogProductReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminCatalogProductReview>>, TError,ApproveAdminCatalogProductReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminCatalogProductReview>>, TError,ApproveAdminCatalogProductReviewMutationVariables, TContext> => {

const mutationKey = getApproveAdminCatalogProductReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminCatalogProductReview>>, ApproveAdminCatalogProductReviewMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  approveAdminCatalogProductReview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminCatalogProductReviewMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminCatalogProductReview>>>
    export type ApproveAdminCatalogProductReviewMutationBody = BodyType<ApproveCatalogProductReviewInput>
    export type ApproveAdminCatalogProductReviewMutationError = ErrorType<ErrorResponse>
    export type ApproveAdminCatalogProductReviewMutationVariables = {data: BodyType<ApproveCatalogProductReviewInput>}

    /**
 * @summary Approve a product for its current source-data snapshot
 */
export const useApproveAdminCatalogProductReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminCatalogProductReview>>, TError,ApproveAdminCatalogProductReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminCatalogProductReview>>,
        TError,
        ApproveAdminCatalogProductReviewMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAdminCatalogProductReviewMutationOptions(options));
    }

export const getResolveAdminCatalogProductReviewsUrl = () => {




  return `/api/admin/brands/reviews/resolve-batch`
}

/**
 * @summary Approve or exclude matching products awaiting review
 */
export const resolveAdminCatalogProductReviews = async (resolveCatalogProductReviewsInput: ResolveCatalogProductReviewsInput, options?: Parameters<typeof customFetch>[1]): Promise<ResolveCatalogProductReviewsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ResolveCatalogProductReviewsResponse>(getResolveAdminCatalogProductReviewsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resolveCatalogProductReviewsInput)
  }
);}





export const getResolveAdminCatalogProductReviewsMutationKey = () => ['resolveAdminCatalogProductReviews'] as const;

export const getResolveAdminCatalogProductReviewsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveAdminCatalogProductReviews>>, TError,ResolveAdminCatalogProductReviewsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveAdminCatalogProductReviews>>, TError,ResolveAdminCatalogProductReviewsMutationVariables, TContext> => {

const mutationKey = getResolveAdminCatalogProductReviewsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveAdminCatalogProductReviews>>, ResolveAdminCatalogProductReviewsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  resolveAdminCatalogProductReviews(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveAdminCatalogProductReviewsMutationResult = NonNullable<Awaited<ReturnType<typeof resolveAdminCatalogProductReviews>>>
    export type ResolveAdminCatalogProductReviewsMutationBody = BodyType<ResolveCatalogProductReviewsInput>
    export type ResolveAdminCatalogProductReviewsMutationError = ErrorType<ErrorResponse>
    export type ResolveAdminCatalogProductReviewsMutationVariables = {data: BodyType<ResolveCatalogProductReviewsInput>}

    /**
 * @summary Approve or exclude matching products awaiting review
 */
export const useResolveAdminCatalogProductReviews = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveAdminCatalogProductReviews>>, TError,ResolveAdminCatalogProductReviewsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveAdminCatalogProductReviews>>,
        TError,
        ResolveAdminCatalogProductReviewsMutationVariables,
        TContext
      > => {
      return useMutation(getResolveAdminCatalogProductReviewsMutationOptions(options));
    }

export const getDeleteAdminCatalogProductReviewUrl = () => {




  return `/api/admin/brands/reviews/delete`
}

/**
 * @summary Delete a product marked as not at source
 */
export const deleteAdminCatalogProductReview = async (approveCatalogProductReviewInput: ApproveCatalogProductReviewInput, options?: Parameters<typeof customFetch>[1]): Promise<DeleteCatalogProductReviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<DeleteCatalogProductReviewResponse>(getDeleteAdminCatalogProductReviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(approveCatalogProductReviewInput)
  }
);}





export const getDeleteAdminCatalogProductReviewMutationKey = () => ['deleteAdminCatalogProductReview'] as const;

export const getDeleteAdminCatalogProductReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminCatalogProductReview>>, TError,DeleteAdminCatalogProductReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminCatalogProductReview>>, TError,DeleteAdminCatalogProductReviewMutationVariables, TContext> => {

const mutationKey = getDeleteAdminCatalogProductReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminCatalogProductReview>>, DeleteAdminCatalogProductReviewMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteAdminCatalogProductReview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminCatalogProductReviewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminCatalogProductReview>>>
    export type DeleteAdminCatalogProductReviewMutationBody = BodyType<ApproveCatalogProductReviewInput>
    export type DeleteAdminCatalogProductReviewMutationError = ErrorType<ErrorResponse>
    export type DeleteAdminCatalogProductReviewMutationVariables = {data: BodyType<ApproveCatalogProductReviewInput>}

    /**
 * @summary Delete a product marked as not at source
 */
export const useDeleteAdminCatalogProductReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminCatalogProductReview>>, TError,DeleteAdminCatalogProductReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminCatalogProductReview>>,
        TError,
        DeleteAdminCatalogProductReviewMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdminCatalogProductReviewMutationOptions(options));
    }

export const getGetAdminSocialPostsUrl = () => {




  return `/api/admin/social-posts`
}

/**
 * @summary Get social post settings, drafts, and generation notes
 */
export const getAdminSocialPosts = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPostsResponse> => {

  return customFetch<AdminSocialPostsResponse>(getGetAdminSocialPostsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSocialPostsQueryKey = () => {
    return [
    `/api/admin/social-posts`
    ] as const;
    }


export const getGetAdminSocialPostsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSocialPosts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSocialPostsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSocialPosts>>> = ({ signal }) => getAdminSocialPosts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSocialPostsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSocialPosts>>>
export type GetAdminSocialPostsQueryError = ErrorType<unknown>


/**
 * @summary Get social post settings, drafts, and generation notes
 */

export function useGetAdminSocialPosts<TData = Awaited<ReturnType<typeof getAdminSocialPosts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSocialPostsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAdminManualSocialPostUrl = () => {




  return `/api/admin/social-posts/manual`
}

/**
 * @summary Create a social post draft from products selected by an admin
 */
export const createAdminManualSocialPost = async (manualSocialPostDraftRequest: ManualSocialPostDraftRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPostDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSocialPostDraftResponse>(getCreateAdminManualSocialPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(manualSocialPostDraftRequest)
  }
);}





export const getCreateAdminManualSocialPostMutationKey = () => ['createAdminManualSocialPost'] as const;

export const getCreateAdminManualSocialPostMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminManualSocialPost>>, TError,CreateAdminManualSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminManualSocialPost>>, TError,CreateAdminManualSocialPostMutationVariables, TContext> => {

const mutationKey = getCreateAdminManualSocialPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminManualSocialPost>>, CreateAdminManualSocialPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAdminManualSocialPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminManualSocialPostMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminManualSocialPost>>>
    export type CreateAdminManualSocialPostMutationBody = BodyType<ManualSocialPostDraftRequest>
    export type CreateAdminManualSocialPostMutationError = ErrorType<ErrorResponse>
    export type CreateAdminManualSocialPostMutationVariables = {data: BodyType<ManualSocialPostDraftRequest>}

    /**
 * @summary Create a social post draft from products selected by an admin
 */
export const useCreateAdminManualSocialPost = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminManualSocialPost>>, TError,CreateAdminManualSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminManualSocialPost>>,
        TError,
        CreateAdminManualSocialPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAdminManualSocialPostMutationOptions(options));
    }

export const getUpdateAdminSocialPostSettingsUrl = () => {




  return `/api/admin/social-posts/settings`
}

/**
 * @summary Save social post settings and editable caption templates
 */
export const updateAdminSocialPostSettings = async (adminSocialPostSettings: AdminSocialPostSettings, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPostsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSocialPostsResponse>(getUpdateAdminSocialPostSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminSocialPostSettings)
  }
);}





export const getUpdateAdminSocialPostSettingsMutationKey = () => ['updateAdminSocialPostSettings'] as const;

export const getUpdateAdminSocialPostSettingsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialPostSettings>>, TError,UpdateAdminSocialPostSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialPostSettings>>, TError,UpdateAdminSocialPostSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateAdminSocialPostSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminSocialPostSettings>>, UpdateAdminSocialPostSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminSocialPostSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminSocialPostSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminSocialPostSettings>>>
    export type UpdateAdminSocialPostSettingsMutationBody = BodyType<AdminSocialPostSettings>
    export type UpdateAdminSocialPostSettingsMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminSocialPostSettingsMutationVariables = {data: BodyType<AdminSocialPostSettings>}

    /**
 * @summary Save social post settings and editable caption templates
 */
export const useUpdateAdminSocialPostSettings = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialPostSettings>>, TError,UpdateAdminSocialPostSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminSocialPostSettings>>,
        TError,
        UpdateAdminSocialPostSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminSocialPostSettingsMutationOptions(options));
    }

export const getGetAdminSocialPublishingUrl = () => {




  return `/api/admin/social-publishing`
}

/**
 * @summary Get Meta connection, automatic publishing, and recent delivery status
 */
export const getAdminSocialPublishing = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPublishingStatus> => {

  return customFetch<AdminSocialPublishingStatus>(getGetAdminSocialPublishingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSocialPublishingQueryKey = () => {
    return [
    `/api/admin/social-publishing`
    ] as const;
    }


export const getGetAdminSocialPublishingQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSocialPublishing>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPublishing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSocialPublishingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSocialPublishing>>> = ({ signal }) => getAdminSocialPublishing({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPublishing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSocialPublishingQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSocialPublishing>>>
export type GetAdminSocialPublishingQueryError = ErrorType<unknown>


/**
 * @summary Get Meta connection, automatic publishing, and recent delivery status
 */

export function useGetAdminSocialPublishing<TData = Awaited<ReturnType<typeof getAdminSocialPublishing>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPublishing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSocialPublishingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAdminMetaOAuthUrl = () => {




  return `/api/admin/social-publishing/connect`
}

/**
 * @summary Start a direct Meta OAuth connection
 */
export const createAdminMetaOAuth = async ( options?: Parameters<typeof customFetch>[1]): Promise<MetaOAuthUrlResponse> => {

  return customFetch<MetaOAuthUrlResponse>(getCreateAdminMetaOAuthUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateAdminMetaOAuthMutationKey = () => ['createAdminMetaOAuth'] as const;

export const getCreateAdminMetaOAuthMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminMetaOAuth>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminMetaOAuth>>, TError,void, TContext> => {

const mutationKey = getCreateAdminMetaOAuthMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminMetaOAuth>>, void> = () => {


          return  createAdminMetaOAuth(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminMetaOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminMetaOAuth>>>

    export type CreateAdminMetaOAuthMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Start a direct Meta OAuth connection
 */
export const useCreateAdminMetaOAuth = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminMetaOAuth>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminMetaOAuth>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateAdminMetaOAuthMutationOptions(options));
    }

export const getUpdateAdminSocialAutoPublishingUrl = () => {




  return `/api/admin/social-publishing/auto`
}

/**
 * @summary Enable or disable automatic Meta publishing
 */
export const updateAdminSocialAutoPublishing = async (socialAutoPublishingRequest: SocialAutoPublishingRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPublishingStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSocialPublishingStatus>(getUpdateAdminSocialAutoPublishingUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(socialAutoPublishingRequest)
  }
);}





export const getUpdateAdminSocialAutoPublishingMutationKey = () => ['updateAdminSocialAutoPublishing'] as const;

export const getUpdateAdminSocialAutoPublishingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialAutoPublishing>>, TError,UpdateAdminSocialAutoPublishingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialAutoPublishing>>, TError,UpdateAdminSocialAutoPublishingMutationVariables, TContext> => {

const mutationKey = getUpdateAdminSocialAutoPublishingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminSocialAutoPublishing>>, UpdateAdminSocialAutoPublishingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminSocialAutoPublishing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminSocialAutoPublishingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminSocialAutoPublishing>>>
    export type UpdateAdminSocialAutoPublishingMutationBody = BodyType<SocialAutoPublishingRequest>
    export type UpdateAdminSocialAutoPublishingMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminSocialAutoPublishingMutationVariables = {data: BodyType<SocialAutoPublishingRequest>}

    /**
 * @summary Enable or disable automatic Meta publishing
 */
export const useUpdateAdminSocialAutoPublishing = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialAutoPublishing>>, TError,UpdateAdminSocialAutoPublishingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminSocialAutoPublishing>>,
        TError,
        UpdateAdminSocialAutoPublishingMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminSocialAutoPublishingMutationOptions(options));
    }

export const getUpdateAdminMetaPageUrl = () => {




  return `/api/admin/social-publishing/page`
}

/**
 * @summary Select the Facebook Page and linked Instagram account to publish to
 */
export const updateAdminMetaPage = async (metaPageSelectionRequest: MetaPageSelectionRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPublishingStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSocialPublishingStatus>(getUpdateAdminMetaPageUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(metaPageSelectionRequest)
  }
);}





export const getUpdateAdminMetaPageMutationKey = () => ['updateAdminMetaPage'] as const;

export const getUpdateAdminMetaPageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMetaPage>>, TError,UpdateAdminMetaPageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminMetaPage>>, TError,UpdateAdminMetaPageMutationVariables, TContext> => {

const mutationKey = getUpdateAdminMetaPageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminMetaPage>>, UpdateAdminMetaPageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAdminMetaPage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminMetaPageMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminMetaPage>>>
    export type UpdateAdminMetaPageMutationBody = BodyType<MetaPageSelectionRequest>
    export type UpdateAdminMetaPageMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminMetaPageMutationVariables = {data: BodyType<MetaPageSelectionRequest>}

    /**
 * @summary Select the Facebook Page and linked Instagram account to publish to
 */
export const useUpdateAdminMetaPage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMetaPage>>, TError,UpdateAdminMetaPageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminMetaPage>>,
        TError,
        UpdateAdminMetaPageMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminMetaPageMutationOptions(options));
    }

export const getDisconnectAdminMetaUrl = () => {




  return `/api/admin/social-publishing/connection`
}

/**
 * @summary Disconnect Meta and turn automatic publishing off
 */
export const disconnectAdminMeta = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPublishingStatus> => {

  return customFetch<AdminSocialPublishingStatus>(getDisconnectAdminMetaUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectAdminMetaMutationKey = () => ['disconnectAdminMeta'] as const;

export const getDisconnectAdminMetaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdminMeta>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectAdminMeta>>, TError,void, TContext> => {

const mutationKey = getDisconnectAdminMetaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectAdminMeta>>, void> = () => {


          return  disconnectAdminMeta(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectAdminMetaMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectAdminMeta>>>

    export type DisconnectAdminMetaMutationError = ErrorType<unknown>


    /**
 * @summary Disconnect Meta and turn automatic publishing off
 */
export const useDisconnectAdminMeta = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdminMeta>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectAdminMeta>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectAdminMetaMutationOptions(options));
    }

export const getCompleteAdminMetaOAuthUrl = () => {




  return `/api/admin/social-publishing/meta/callback`
}

/**
 * @summary Complete the server-side Meta OAuth redirect
 */
export const completeAdminMetaOAuth = async ( options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getCompleteAdminMetaOAuthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompleteAdminMetaOAuthQueryKey = () => {
    return [
    `/api/admin/social-publishing/meta/callback`
    ] as const;
    }


export const getCompleteAdminMetaOAuthQueryOptions = <TData = Awaited<ReturnType<typeof completeAdminMetaOAuth>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof completeAdminMetaOAuth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompleteAdminMetaOAuthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof completeAdminMetaOAuth>>> = ({ signal }) => completeAdminMetaOAuth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof completeAdminMetaOAuth>>, TError, TData> & { queryKey: QueryKey }
}

export type CompleteAdminMetaOAuthQueryResult = NonNullable<Awaited<ReturnType<typeof completeAdminMetaOAuth>>>
export type CompleteAdminMetaOAuthQueryError = ErrorType<string>


/**
 * @summary Complete the server-side Meta OAuth redirect
 */

export function useCompleteAdminMetaOAuth<TData = Awaited<ReturnType<typeof completeAdminMetaOAuth>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof completeAdminMetaOAuth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCompleteAdminMetaOAuthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAdminSocialPostUrl = (draftId: string,) => {




  return `/api/admin/social-posts/${draftId}`
}

/**
 * @summary Edit captions, swap a product, remove an image, or rotate wording
 */
export const updateAdminSocialPost = async (draftId: string,
    adminSocialPostUpdateRequest: AdminSocialPostUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPostDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSocialPostDraftResponse>(getUpdateAdminSocialPostUrl(draftId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminSocialPostUpdateRequest)
  }
);}





export const getUpdateAdminSocialPostMutationKey = () => ['updateAdminSocialPost'] as const;

export const getUpdateAdminSocialPostMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialPost>>, TError,UpdateAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialPost>>, TError,UpdateAdminSocialPostMutationVariables, TContext> => {

const mutationKey = getUpdateAdminSocialPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminSocialPost>>, UpdateAdminSocialPostMutationVariables> = (props) => {
          const {draftId,data} = props ?? {};

          return  updateAdminSocialPost(draftId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminSocialPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminSocialPost>>>
    export type UpdateAdminSocialPostMutationBody = BodyType<AdminSocialPostUpdateRequest>
    export type UpdateAdminSocialPostMutationError = ErrorType<ErrorResponse>
    export type UpdateAdminSocialPostMutationVariables = {draftId: string;data: BodyType<AdminSocialPostUpdateRequest>}

    /**
 * @summary Edit captions, swap a product, remove an image, or rotate wording
 */
export const useUpdateAdminSocialPost = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSocialPost>>, TError,UpdateAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminSocialPost>>,
        TError,
        UpdateAdminSocialPostMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminSocialPostMutationOptions(options));
    }

export const getApproveAdminSocialPostUrl = (draftId: string,) => {




  return `/api/admin/social-posts/${draftId}/approve`
}

/**
 * @summary Verify eligibility, lazily render images, and approve
 */
export const approveAdminSocialPost = async (draftId: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPostDraftResponse> => {

  return customFetch<AdminSocialPostDraftResponse>(getApproveAdminSocialPostUrl(draftId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveAdminSocialPostMutationKey = () => ['approveAdminSocialPost'] as const;

export const getApproveAdminSocialPostMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminSocialPost>>, TError,ApproveAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminSocialPost>>, TError,ApproveAdminSocialPostMutationVariables, TContext> => {

const mutationKey = getApproveAdminSocialPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminSocialPost>>, ApproveAdminSocialPostMutationVariables> = (props) => {
          const {draftId} = props ?? {};

          return  approveAdminSocialPost(draftId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminSocialPostMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminSocialPost>>>

    export type ApproveAdminSocialPostMutationError = ErrorType<ErrorResponse>
    export type ApproveAdminSocialPostMutationVariables = {draftId: string}

    /**
 * @summary Verify eligibility, lazily render images, and approve
 */
export const useApproveAdminSocialPost = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminSocialPost>>, TError,ApproveAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminSocialPost>>,
        TError,
        ApproveAdminSocialPostMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAdminSocialPostMutationOptions(options));
    }

export const getSkipAdminSocialPostUrl = (draftId: string,) => {




  return `/api/admin/social-posts/${draftId}/skip`
}

/**
 * @summary Skip a social post draft
 */
export const skipAdminSocialPost = async (draftId: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPostDraftResponse> => {

  return customFetch<AdminSocialPostDraftResponse>(getSkipAdminSocialPostUrl(draftId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSkipAdminSocialPostMutationKey = () => ['skipAdminSocialPost'] as const;

export const getSkipAdminSocialPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipAdminSocialPost>>, TError,SkipAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skipAdminSocialPost>>, TError,SkipAdminSocialPostMutationVariables, TContext> => {

const mutationKey = getSkipAdminSocialPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipAdminSocialPost>>, SkipAdminSocialPostMutationVariables> = (props) => {
          const {draftId} = props ?? {};

          return  skipAdminSocialPost(draftId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipAdminSocialPostMutationResult = NonNullable<Awaited<ReturnType<typeof skipAdminSocialPost>>>

    export type SkipAdminSocialPostMutationError = ErrorType<unknown>
    export type SkipAdminSocialPostMutationVariables = {draftId: string}

    /**
 * @summary Skip a social post draft
 */
export const useSkipAdminSocialPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipAdminSocialPost>>, TError,SkipAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof skipAdminSocialPost>>,
        TError,
        SkipAdminSocialPostMutationVariables,
        TContext
      > => {
      return useMutation(getSkipAdminSocialPostMutationOptions(options));
    }

export const getRenderAdminSocialPostUrl = (draftId: string,) => {




  return `/api/admin/social-posts/${draftId}/render`
}

/**
 * @summary Lazily render a carousel when an admin opens its preview
 */
export const renderAdminSocialPost = async (draftId: string, options?: Parameters<typeof customFetch>[1]): Promise<RenderAdminSocialPost200> => {

  return customFetch<RenderAdminSocialPost200>(getRenderAdminSocialPostUrl(draftId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRenderAdminSocialPostMutationKey = () => ['renderAdminSocialPost'] as const;

export const getRenderAdminSocialPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renderAdminSocialPost>>, TError,RenderAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renderAdminSocialPost>>, TError,RenderAdminSocialPostMutationVariables, TContext> => {

const mutationKey = getRenderAdminSocialPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renderAdminSocialPost>>, RenderAdminSocialPostMutationVariables> = (props) => {
          const {draftId} = props ?? {};

          return  renderAdminSocialPost(draftId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenderAdminSocialPostMutationResult = NonNullable<Awaited<ReturnType<typeof renderAdminSocialPost>>>

    export type RenderAdminSocialPostMutationError = ErrorType<unknown>
    export type RenderAdminSocialPostMutationVariables = {draftId: string}

    /**
 * @summary Lazily render a carousel when an admin opens its preview
 */
export const useRenderAdminSocialPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renderAdminSocialPost>>, TError,RenderAdminSocialPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof renderAdminSocialPost>>,
        TError,
        RenderAdminSocialPostMutationVariables,
        TContext
      > => {
      return useMutation(getRenderAdminSocialPostMutationOptions(options));
    }

export const getPublishAdminSocialPostNowUrl = (draftId: string,) => {




  return `/api/admin/social-posts/${draftId}/publish`
}

/**
 * @summary Publish a reviewed post immediately to its connected Meta accounts
 */
export const publishAdminSocialPostNow = async (draftId: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminSocialPublishingStatus> => {

  return customFetch<AdminSocialPublishingStatus>(getPublishAdminSocialPostNowUrl(draftId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishAdminSocialPostNowMutationKey = () => ['publishAdminSocialPostNow'] as const;

export const getPublishAdminSocialPostNowMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAdminSocialPostNow>>, TError,PublishAdminSocialPostNowMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishAdminSocialPostNow>>, TError,PublishAdminSocialPostNowMutationVariables, TContext> => {

const mutationKey = getPublishAdminSocialPostNowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAdminSocialPostNow>>, PublishAdminSocialPostNowMutationVariables> = (props) => {
          const {draftId} = props ?? {};

          return  publishAdminSocialPostNow(draftId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAdminSocialPostNowMutationResult = NonNullable<Awaited<ReturnType<typeof publishAdminSocialPostNow>>>

    export type PublishAdminSocialPostNowMutationError = ErrorType<ErrorResponse>
    export type PublishAdminSocialPostNowMutationVariables = {draftId: string}

    /**
 * @summary Publish a reviewed post immediately to its connected Meta accounts
 */
export const usePublishAdminSocialPostNow = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAdminSocialPostNow>>, TError,PublishAdminSocialPostNowMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishAdminSocialPostNow>>,
        TError,
        PublishAdminSocialPostNowMutationVariables,
        TContext
      > => {
      return useMutation(getPublishAdminSocialPostNowMutationOptions(options));
    }

export const getGetAdminSocialPostImageUrl = (draftId: string,
    imageIndex: number,) => {




  return `/api/admin/social-posts/${draftId}/images/${imageIndex}`
}

/**
 * @summary Serve an authenticated generated carousel image
 */
export const getAdminSocialPostImage = async (draftId: string,
    imageIndex: number, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetAdminSocialPostImageUrl(draftId,imageIndex),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSocialPostImageQueryKey = (draftId: string,
    imageIndex: number,) => {
    return [
    `/api/admin/social-posts/${draftId}/images/${imageIndex}`
    ] as const;
    }


export const getGetAdminSocialPostImageQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSocialPostImage>>, TError = ErrorType<ErrorResponse>>(draftId: string,
    imageIndex: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPostImage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSocialPostImageQueryKey(draftId,imageIndex);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSocialPostImage>>> = ({ signal }) => getAdminSocialPostImage(draftId,imageIndex, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: draftId !== null && draftId !== undefined && imageIndex !== null && imageIndex !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPostImage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSocialPostImageQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSocialPostImage>>>
export type GetAdminSocialPostImageQueryError = ErrorType<ErrorResponse>


/**
 * @summary Serve an authenticated generated carousel image
 */

export function useGetAdminSocialPostImage<TData = Awaited<ReturnType<typeof getAdminSocialPostImage>>, TError = ErrorType<ErrorResponse>>(
 draftId: string,
    imageIndex: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSocialPostImage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSocialPostImageQueryOptions(draftId,imageIndex,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSavedOrdersUrl = () => {




  return `/api/admin/orders`
}

/**
 * @summary List saved customer orders
 */
export const listSavedOrders = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminOrdersResponse> => {

  return customFetch<AdminOrdersResponse>(getListSavedOrdersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSavedOrdersQueryKey = () => {
    return [
    `/api/admin/orders`
    ] as const;
    }


export const getListSavedOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listSavedOrders>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSavedOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSavedOrdersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedOrders>>> = ({ signal }) => listSavedOrders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSavedOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSavedOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listSavedOrders>>>
export type ListSavedOrdersQueryError = ErrorType<ErrorResponse>


/**
 * @summary List saved customer orders
 */

export function useListSavedOrders<TData = Awaited<ReturnType<typeof listSavedOrders>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSavedOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSavedOrdersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportSavedOrdersCsvUrl = (params?: ExportSavedOrdersCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/orders/export.csv?${stringifiedParams}` : `/api/admin/orders/export.csv`
}

/**
 * @summary Export saved customer orders as CSV
 */
export const exportSavedOrdersCsv = async (params?: ExportSavedOrdersCsvParams, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getExportSavedOrdersCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportSavedOrdersCsvQueryKey = (params?: ExportSavedOrdersCsvParams,) => {
    return [
    `/api/admin/orders/export.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportSavedOrdersCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportSavedOrdersCsv>>, TError = ErrorType<ErrorResponse>>(params?: ExportSavedOrdersCsvParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportSavedOrdersCsv>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportSavedOrdersCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSavedOrdersCsv>>> = ({ signal }) => exportSavedOrdersCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSavedOrdersCsv>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportSavedOrdersCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportSavedOrdersCsv>>>
export type ExportSavedOrdersCsvQueryError = ErrorType<ErrorResponse>


/**
 * @summary Export saved customer orders as CSV
 */

export function useExportSavedOrdersCsv<TData = Awaited<ReturnType<typeof exportSavedOrdersCsv>>, TError = ErrorType<ErrorResponse>>(
 params?: ExportSavedOrdersCsvParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportSavedOrdersCsv>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportSavedOrdersCsvQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSavedOrderStatusUrl = (reference: string,) => {




  return `/api/admin/orders/${reference}`
}

/**
 * @summary Update a saved order status
 */
export const updateSavedOrderStatus = async (reference: string,
    orderStatusUpdate: OrderStatusUpdate, options?: Parameters<typeof customFetch>[1]): Promise<SavedOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SavedOrderResponse>(getUpdateSavedOrderStatusUrl(reference),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(orderStatusUpdate)
  }
);}





export const getUpdateSavedOrderStatusMutationKey = () => ['updateSavedOrderStatus'] as const;

export const getUpdateSavedOrderStatusMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedOrderStatus>>, TError,UpdateSavedOrderStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSavedOrderStatus>>, TError,UpdateSavedOrderStatusMutationVariables, TContext> => {

const mutationKey = getUpdateSavedOrderStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSavedOrderStatus>>, UpdateSavedOrderStatusMutationVariables> = (props) => {
          const {reference,data} = props ?? {};

          return  updateSavedOrderStatus(reference,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSavedOrderStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateSavedOrderStatus>>>
    export type UpdateSavedOrderStatusMutationBody = BodyType<OrderStatusUpdate>
    export type UpdateSavedOrderStatusMutationError = ErrorType<ErrorResponse>
    export type UpdateSavedOrderStatusMutationVariables = {reference: string;data: BodyType<OrderStatusUpdate>}

    /**
 * @summary Update a saved order status
 */
export const useUpdateSavedOrderStatus = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSavedOrderStatus>>, TError,UpdateSavedOrderStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSavedOrderStatus>>,
        TError,
        UpdateSavedOrderStatusMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSavedOrderStatusMutationOptions(options));
    }

export const getDeleteSavedOrderUrl = (reference: string,) => {




  return `/api/admin/orders/${reference}`
}

/**
 * @summary Delete a saved customer order
 */
export const deleteSavedOrder = async (reference: string, options?: Parameters<typeof customFetch>[1]): Promise<SavedOrderDeletion> => {

  return customFetch<SavedOrderDeletion>(getDeleteSavedOrderUrl(reference),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSavedOrderMutationKey = () => ['deleteSavedOrder'] as const;

export const getDeleteSavedOrderMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedOrder>>, TError,DeleteSavedOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSavedOrder>>, TError,DeleteSavedOrderMutationVariables, TContext> => {

const mutationKey = getDeleteSavedOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSavedOrder>>, DeleteSavedOrderMutationVariables> = (props) => {
          const {reference} = props ?? {};

          return  deleteSavedOrder(reference,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSavedOrderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSavedOrder>>>

    export type DeleteSavedOrderMutationError = ErrorType<ErrorResponse>
    export type DeleteSavedOrderMutationVariables = {reference: string}

    /**
 * @summary Delete a saved customer order
 */
export const useDeleteSavedOrder = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedOrder>>, TError,DeleteSavedOrderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSavedOrder>>,
        TError,
        DeleteSavedOrderMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSavedOrderMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthStatus>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<HealthStatus>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthStatus>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







